export default {
cont_txt1: `Games`,
  cont_txt2: `Apps`,
  cont_txt3: `Movies`,
  cont_txt4: `Books`,
  cont_txt5: `Children`,
  cont_txt6: `OT.GAME Slots - Casino Games`,
  cont_txt7: `BETTA GAMES`,
  cont_txt8: `Verified by the app`,
  cont_txt9: `reviews`,
  cont_txt10: `50k+`,
  cont_txt11: `Downloads`,
  cont_txt12: `Rated for 18+`,
  cont_txt13: `Quick Install`,
  cont_txt14: `Download within 15 seconds`,
  cont_txt15: `Share`,
  cont_txt16: `Add to wish list`,
  cont_txt17: `wish list`,
  cont_txt18: `About this game`,
  cont_txt19: `🎮 OT.GAME is a leading online gambling platform in Nigeria, holding a legal license issued by the National Lottery Regulatory Commission (NLRC). The Group has been in the industry for 5 years and is known for its integrity and brand influence, providing the best experiences in slot machines, innovative gameplay, generous bonuses, and exclusive VIP promotions. OT.GAME Casino is an official partner of the Paystack and Flutterwave payment systems, ensuring fast and secure transactions. With the support of the government and authorized agencies, OT.GAME continues to innovate and offer reliable and exciting entertainment.`,
  cont_txt20: `Atualizado em`,
  cont_txt21: `10 de fev. de 2025`,
  cont_txt22: `casino`,
  cont_txt23: `Slot Machines`,
  cont_txt24: `Leisure`,
  cont_txt25: `Single`,
  cont_txt26: `Stylization`,
  cont_txt27: `other`,
  cont_txt28: `Data Security`,
  cont_txt29: `Your security begins with understanding how developers collect and share your data. Data security and privacy practices may vary depending on usage, region, and age. The developer has provided the following information, which may be updated over time.`,
  cont_txt30: `Data is not shared with`,
  cont_txt31: `third parties`,
  cont_txt32: `Learn more about how`,
  cont_txt33: `developers declare`,
  cont_txt34: `sharing`,
  cont_txt35: `This app may collect these types of`,
  cont_txt36: `data`,
  cont_txt37: `Location, Activity in app, and`,
  cont_txt38: `Device identifiers and others`,
  cont_txt39: `Data is encrypted in transit`,
  cont_txt40: `You can request deletion of data`,
  cont_txt41: `More details`,
  cont_txt42: `Ratings and reviews`,
  cont_txt43: `Ratings and reviews are verified`,
  cont_txt44: `Phone`,
  cont_txt45: `Tablet`,
  cont_txt46: `1,910 reviews`,
  cont_txt47: `KUMA`,
  cont_txt48: `September 5, 2024`,
  cont_txt49: `The game is good, but it needs some incentives. Overall, I really liked it! It's very healthy to distract and play! Loved the piglets kkk`,
  cont_txt50: `This review was marked as helpful by 52 people`,
  cont_txt51: `Did you find this useful?`,
  cont_txt52: `Yes`,
  cont_txt53: `No`,
  cont_txt54: `IKUN`,
  cont_txt55: `August 19, 2024`,
  cont_txt56: `I really like it. The game is super fun and the jackpot explodes every day`,
  cont_txt57: `This review was marked as helpful by 52 people`,
  cont_txt58: `Did you find this useful?`,
  cont_txt59: `LISHA`,
  cont_txt60: `June 9, 2024`,
  cont_txt61: `Very fun and it doesn't keep locking up and full of ads. It's really good!`,
  cont_txt62: `This review was marked as helpful by 52 people`,
  cont_txt63: `Did you find this useful?`,
  cont_txt64: `See all reviews`,
  cont_txt65: `What's new`,
  cont_txt66: `Hello, Fortune Tiger Slot fans!`,
  cont_txt67: `Here's a new update:`,
  cont_txt68: `- Performance improvements`,
  cont_txt69: `Enjoy and have fun!`,
  cont_txt70: `Similar games`,
  cont_txt71: `Flag as inappropriate`,
  cont_txt72: `Play Pass`,
  cont_txt73: `Play Points`,
  cont_txt74: `Gift cards`,
  cont_txt75: `Redeem`,
  cont_txt76: `Refund policy`,
  cont_txt77: `Children and family`,
  cont_txt78: `Family Guide`,
  cont_txt79: `Family sharing`,
  cont_txt80: `Terms of Service`,
  cont_txt81: `About Google Play`,
  cont_txt82: `Privacy`,
  cont_txt83: `Developers`,
  cont_txt84: `Google Store`,
  cont_txt85: `All prices include tax.`,
  cont_txt86: `Nigeria (English)`,
  cont_txt87: `Cash Craze: Casino Slots Games`,
  cont_txt88: `Casual Joy Games`,
  cont_txt89: `Charge Buffalo Slot - TaDa Games`,
  cont_txt90: `FUFAFA TECHNOLOGY LTD CO.`,
  cont_txt91: `Jackpot Magic Slots`,
  cont_txt92: `Big Fish Games`,
  cont_txt93: `Diamond Slot - Slot Game`,
  cont_txt94: `International Games System Co., Ltd.`,
  cont_txt95: `Bingo Bonus Casino - TaDa Game`,
  cont_txt96: `FUFAFA TECHNOLOGY LTD CO.`,
  cont_txt97: `Infinity Slots - Casino Games`,
  cont_txt98: `Murka Games Limited`,

  menu_search_placeholder: 'Pesquisar jogo',
  search_title: 'Pesquisar',
  search_placeholder: 'Pesquisar jogo',
  search_history: 'Histórico de pesquisa',
  search_clear: 'Limpar',
  search_popular: 'Pesquisas populares',
  search_recommended: 'Jogos recomendados',
  game_detail_title: 'Jogo',
  game_detail_rtp: 'RTP',
  game_detail_min_bet: 'APOSTA MÍNIMA',
  game_detail_play: 'Jogar',
  game_detail_preview: 'Prévia do jogo',
  game_detail_recommend: 'Jogos recomendados',
  qb_monery: 'R$',
  account: 'PIX',
  Depósito: 'Depósito',
  VIP: 'VIP',
  Saque: 'Saque',
  Registro: 'Registro',
  Entrar: 'Entrar',
  Apostas: 'Apostas',
  Agente: 'Agente',
  Promoção: 'Promoção',
  Reminder: 'Reminder',
  Início: 'Início',
  Bônus: 'Bônus',
  Enviar: 'Enviar',
  Compartilhar: 'Compartilhar',
  Meu: 'Meu',
  BRL: 'BRL',
  ALL: 'ALL',
  noempt: 'Sem Registros',
  Recarregar: 'Recarregar',
  Receber: 'Receber',
  Recebido: 'Recebido',
  Regras: 'Regras',
  Obter: 'Obter',
  Sucesso: 'Sucesso',
  Cancelar: 'Cancelar',
  Confirmar: 'Confirmar',
  Detalhes: 'Detalhes',
  TopNav_txt: 'Roda',
  TopNav_txt1: 'Check-in VIP',
  TopNav_txt2: '100% Primeiro',
  TopNav_txt3: 'Baú Atv.',
  TopNav_txt4: 'CEV',
  TopNav_txt5: 'CFA',
  index_txt: `Registered successfully! Let's play a game now~`,
  index_txt2: `Deposit Now`,
  home_txt: 'acabou de retirar',
  home_txt2: 'List of winners',
  home_txt3: 'Mais Benefícios Águardam Você nos Canais Oficiais',
  home_txt4: 'Compartilhar nas Redes Sociais',
  home_txt5:
    'otlotter.com é uma marca administrada pOr GAMEWIZ BRASIL LTDA, CNPJN56.195.099/0001-89,devidamente autorizada pelo Ministério daFazendasob aAutorizac30 SPA/MFn°2.104-10',
  home_txt6: '@2024 otlotter.com All rights reserved',
  home_txt7: 'Não mostrar novamente hoje',
  home_txt8: 'Nunca perguntar novamente',
  home_txt9: 'Deposite Já!',
  bonus_title: `Invite Partners`,
  bonus_title2: `Primeiro Depósito`,
  bonus_title3: `Fundo de auxílio diário`,
  bonus_title4: `Primeiro registro`,
  bonus_title5: `Pacote Vemnelho`,
  bonus_title6: `Evento Baú do Tesouro`,
  bonus_title7: `VIP Bônus de atualização`,
  bonus_title8: `Reembolsos de Equipe`,
  bonus_title9: `VIP Sign-In Bonus`,
  bonus_txt: `<p>
            Quando você tiver tempo suficiente e recursos promocionais,
            convidamos você a entrar em contato diretamente com nosso gerente de
            contato! Criaremos um plano detalhado de salário semanal! Desde que
            você tenha vontade, desde que tenha coragem! Desde que tenha os
            recursos! Convidamos você a se juntar a nós!
          </p>
          <p class="m-t-20">
            Condições para se tornar um agente: Influenciador conhecido nas
            redes sociais, apaixonado por promoção. Você gosta da plataforma
            otlotter.com? Você tem um grande número de seguidores ou grupos sociais
            que podem convencer um número significativo de usuários válidos para
            a plataforma otlotter.com? Coopere conosco a longo prazo e participe de
            nossos planos operacionais e atividades promocionais.
          </p>
          <p class="m-t-20">
            Aguardamos ansiosamente sua participação e financermos: ativos VIP
            exclusivos e serviços exclusivos de liquidação de comissões. Outras
            recompensas, como dividendos semanais de lucro. Salário semanal
            alto: 10.000 - 50.000 BRL (sem limite máximo).
          </p>`,
  bonus_txt2: `<p>
          Regras:<br />1. Participar do plano de salário semanal do parceiro e
          das atividades da plataforma podem ser feitos simultaneamente.<br />2.
          O salário semanal é pago pontualmente todas as segundas-feiras.<br />3.Nosso
          plano de salário semanal não tem restrições. Se seus seguidores são
          ativo ou abaixo de 10.000, você pode entrar em contato com nosso
          gerente para criar um plano de salário semanal VIP exclusivo para
          você.<br />
          4. O salário semanal é depositado diretamente na sua conta da
          plataforma.
          <br />5. Rejeitamos contas falsas. Qualquer conta falsa detectada será
          permanentemente bloqueada.
        </p>`,
  bonus_txt3: `<p class="font-color">
            Primeiro depósito Duração do evento: De agora até a data final a ser
            anunciada posteriormente.
          </p>
          <p class="m-t-20 m-b-10 f-t-16 f-w">Regras do Evento:</p>
          <p class="font-color">
            Os usuários podem solicitar recompensas de bônus com base em seu
            primeiro depósito, com um bônus máximo de 100% de BRL por depósito
            único. Para sacar o bônus, é necessário atingir o valor de aposta
            exigido, que é calculado como |Bônus × n vezes| do valor do
            depósito.
          </p>
          <p class="m-t-20 f-t-16 f-w m-b-10">
            Níveis de Bônus do Primeiro Depósito:
          </p>
          <div class="font-color" style="line-height: 20px">
            <p>
              Valor do Depósito Porcentagem do Bônus Requisito de Aposta
              (Multiplicador)
            </p>
            <p>30-49 3 1</p>
            <p>50-99 8 1</p>
            <p>100-299 20 1</p>
            <p>300-499 80 1</p>
            <p>500-999 150 1</p>
            <p>1.000-2.999 300 1</p>
            <p>3.000 1.000 1</p>
            <p class="m-t-20 f-t-16 f-w m-b-10">
              Níveis de bônus de segundo depósito:
            </p>
            <p>
              Valor do depósito Bônus Percentagem Requisito de aposta
              (multiplicador)
            </p>
            <p>30-49 10% 1</p>
            <p>50-99 10% 1</p>
            <p>100-299 10% 1</p>
            <p>300-499 10% 1</p>
            <p>500-999 10% 1</p>
            <p>1.000-2.999 10% 1</p>
            <p>3.000 10% 1</p>
            <p class="m-t-20 f-t-16 f-w m-b-10" >
              Níveis de bônus de depósito subsequentes:
            </p>
            <p>
              Valor do depósito Bônus Percentagem Requisito de aposta
              (multiplicador)
            </p>
            <p>30-49 10% 1</p>
            <p>50-99 10% 1</p>
            <p>100-299 10% 1</p>
            <p>300-499 10% 1</p>
            <p>500-999 10% 1</p>
            <p>1.000-2.999 10% 1</p>
            <p>3.000 10% 1</p>
          </div>

          <p class="m-t-20 f-t-16 f-w m-b-10">Exemplo:</p>
          <div class="font-color" style="line-height: 20px">
            <p>
              Um depósito de 2.000 Reais lhe renderá um bônus de 5% (100 Reais).
            </p>
            <p>
              Um depósito de 2.000 Reais lhe renderá um bônus de 5% (100 Reais).
              Isso significa que você precisa apostar (100 Reais × 5) + 2.000
              Reais = 2.500 Reais.
            </p>
            <p>
              Assim que 2.500 Reais em apostas forem feitas, o bônus poderá ser
              sacado.
            </p>
            <p>Uma aposta em dinheiro de 20.000 Reais desbloqueará o bônus.</p>
            <p class="m-t-20 f-t-16 f-w m-b-10" >
              Observações:
            </p>
            <p>
              1. Esta promoção não pode ser cancelada após ser aplicada com
              sucesso. Para remover quaisquer restrições de conta, o requisito
              de aposta específico da promoção deve ser concluído.
            </p>
            <p>
              2. Se arbitragem, hedge ou comportamento desonesto de obtenção de
              lucro for detectado, a elegibilidade promocional será cancelada e
              todas as recompensas de bônus serão perdidas.
            </p>
            <p>
              3. O valor de aposta válido inclui apenas apostas liquidadas que
              resultaram em vitória ou derrota. Quaisquer eventos cancelados ou
              anulados não contarão para a aposta válida.
            </p>
            <p>
              4. Todo jogador válido pode participar. Se quaisquer violações
              forem detectadas, reservamo-nos o direito de revisar e reaver
              indefinidamente quaisquer bônus e lucros gerados.
            </p>
            <p>
              5. Se você sacar antes de cumprir os requisitos de aposta, o bônus
              será deduzido pelo sistema.
            </p>
          </div>`,
  bonus_txt4: `Recarregue agora`,
  bonus_txt5: `Garanta uma conta, telefone e número de cartão únicos. Múltiplos
          registros para obter bônus resultarão no banimento permanente da
          conta.`,
  bonus_txt6: `LSS CASHCACK`,
  bonus_txt7: `Dinheiro de volta`,
  bonus_txt8: 'Cashback Rate VIP',
  bonus_txt9: 'Perda',
  bonus_txt10: 'Dlnhelro de volta',
  bonus_txt11: `<p class="m-t-15 l-h-20" style="margin-left: 5px">
          1.Você pode receber uma oportunidade de recompensa em cashback todos
          os dias.
        </p>
        <p class="content-c5--cash">
          2.O valor das apostas é calculado a partir das 00:00 de ontem até às
          00:00 de hoje.
        </p>
        <p class="content-c5--cash">
          3.Você pode registrar a recompensa entre 05:00 e 23:59 de hoje.
        </p>
        <p class="content-c5--cash">
          4.O valor do cashback é baseado no valor real de ganhos/perdas, e você
          pode receber o cashback correspondente, conforme mostrado na tabela.
        </p>
        <p class="content-c5--cash">
          5.Se você não fizer nenhuma aposta durante o período de reembolso ou
          se seus ganhos ultrapassarem o valor apostado, você não terá direito
          ao reembolso.
        </p>
        <p class="content-c5--cash">
          6.O cashback máximo por pessoa, por vez, é de 1.000.000 BRL.
        </p>
        <p class="content-c5--cash">
          7.No entanto, antes de poder sacar a recompensa, você deve fazer pelo
          menos 2 rodadas de apostas utilizando o valor recebido.
        </p>
        <p class="content-c5--cash">
          8.A decisão final sobre todos os assuntos fica a critério da otlotter.com.
        </p>`,
  bonus_txt12: `Detalhes do Evento`,
  bonus_txt13: `Novos usu¡rios cadastrados receberÃäo um bÃnus de bÃnusaleatório R$20
        gr¡tis,Complete as tarefas designadas parareceberas recompensas
        correspondentes;`,
  bonus_txt14: `<p class="f-t-16 f-w m-t-15">Detalhes do Evento</p>
        <p class="m-t-15">
          1、Após o cadastro como membro,Complete as tarefas designadaspara
          receber as recompensas correspondentes;
        </p>
        <p class="m-t-10">2、BÃnus disponível apenas em jogos de slots PG</p>
        <p class="m-t-10">
          3、Cada membro e cada endereco lP só podem participar uma vezSe v¡rias
          contas usarem o mesmo endereco lP, seräo consideradasa mesma pessoa e
          nǎo poderäo participar novamente;
        </p>
        <p class="m-t-10">
          4、Membros que obtiveram lucros usando os bónus deste evento
          esolicitaram saque. O nivel VlP precisa atingir VIP1 para fazersaques
          completos.
        </p>
        <p class="m-t-10">
          5、otlotter.com reserva-se o direito de alterar, interromper ou cancelar
          aatividade a qualquer momento.
        </p>`,
  bonus_txt15: `Conecte-se & Registrar`,
  bonus_txt16: `Coletado com sucesso.`,
  bonus_txt17: `HORA DE LIBERAÇÃO`,
  bonus_txt18: `12:00-12:59`,
  bonus_txt19: `18:00-18:59`,
  bonus_txt20: `21:00-21:59`,
  bonus_txt21: `<p class="m-t-10">
          1.Você receberá uma recompensa em dinheiro de volta toda semana.
        </p>
        <p class="m-t-10">
          2.O valor da aposta é calculado das 00:00 de segunda-feira às 23:59 de
          domingo.
        </p>
        <p class="m-t-10">
          3.Você pode resgatar sua recompensa a partir das 00:00 da
          segunda-feira da próxima semana até às 23:59 da segunda-feira.
        </p>
        <p class="m-t-10">
          4.O cashback é calculado multiplicando sua perda real pela percentagem
          de cashback.
        </p>
        <p class="m-t-10">
          5.Se você não fizer nenhuma aposta durante o período de cashback ou se
          seus ganhos forem maiores que suas perdas da semana anterior, você não
          receberá o cashback.
        </p>
        <p class="m-t-10">
          6.O cashback máximo por pessoa por semana é de 5.000 de BRL.
        </p>
        <p class="m-t-10">
          7.No entanto, antes de poder sacar a recompensa, você precisa fazer
          pelo menos 3 rodadas de apostas com o valor recebido.
        </p>
        <p class="m-t-10">
          8.A decisão final sobre todos os assuntos fica a critério da otlotter.com.
        </p>`,
  bonus_txt22: `Depositar e Participar`,
  bonus_txt23: `Meu link`,
  bonus_txt24: `Código de Convite:`,
  bonus_txt25: `Subordinados válidos`,
  bonus_txt26: `pessoas`,
  bonus_txt26_single: `pessoa`,
  bonus_txt27: `O que é um número promocional válido?`,
  bonus_txt28: `(Atenda a todos os requisitos abaixo)`,
  bonus_txt29: `Depósitos totais subordinados`,
  bonus_txt30: `20 ou mais`,
  bonus_txt31: `Aposta total do subordinado`,
  bonus_txt32: `200 ou mais`,
  bonus_txt33: `<p class="m-t-15">
          1.Indique amigos para abrir o Baú do Tesouro. Ao completar diferentes
          quantidades de indicações, você poderá ganhar os bauxs
          correspondentes, com um valor máximo de 20.000.000. Quanto mais amigos
          você desenvolver, maior será a recompensa.
        </p>
        <p class="m-t-10">
          2.Esta atividade é um presente adicional da plataforma e também
          acumula outras recompensas e comissões da agência, ou seja, você pode
          aproveitar várias recompensas simultaneamente. Os subordinados diretos
          recém-registrados em cada ciclo só serão válidos se atenderem às
          condições da atividade.
        </p>
        <p class="m-t-10">
          3.Membros de nível inferior podem fazer apostas válidas na plataforma
          sem restrições.
        </p>
        <p class="m-t-10">
          4.As recompensas devem ser resgatadas manualmente na plataforma;
          recompensas expiradas serão distribuídas automaticamente.
        </p>
        <p class="m-t-10">
          5.O bônus (excluindo o capital) concedido neste evento exige 0 apostas
          válidas para ser retirado. As apostas não são limitadas às plataformas
          de jogo.
        </p>
        <p class="m-t-10">
          6.Este evento é destinado apenas a operações manuais normais do
          titular da conta. O uso de contas, softwares de trapaça, bots, apostas
          entre diferentes contas, manipulação mútua, arbitragem, uso de APIs,
          protocolos, exploração de vulnerabilidades, controle em grupo ou
          outros meios técnicos são proibidos. Caso contrário, as recompensas
          podem ser canceladas ou deduzidas, e a conta pode ser congelada ou até
          mesmo incluída na lista negra.
        </p>
        <p class="m-t-10 m-b-20">
          7.Para evitar divergências na interpretação do texto, a plataforma
          reserva-se o direito de interpretação final deste evento.
        </p>`,
  bonus_txt34: `Valor da Recompensa:`,
  bonus_txt35: `Taxa de Cashback VIP`,
  bonus_txt36: `Nível`,
  bonus_txt37: `Recompensa`,
  bonus_txt38: `<p class="content-c5-sign" style="margin-top: 15px">
        Durante o Período do Evento, os Usuários Podem Receber Recompensas por
        Upgrades de Nível VIP. Regras:
      </p>
      <p class="content-c5-sign">
        1. Os usuários devem completar os requisitos de recarga e valor apostado
        válido para o nível VIP especificado. Uma vez concluído, podem
        reivindicar a quantidade correspondente de recompensa para seu nível
        VIP.
      </p>
      <p class="content-c5-sign">
        2. Quando o nível VIP de um usuário aumenta, a quantidade de apostas
        válidas históricas será redefinida. Os usuários precisarão começar uma
        nova rodada de apostas válidas para alcançar o novo nível e reivindicar
        a quantidade de recompensa.
      </p>
      <p class="content-c5-sign">
        3. Se o usuário não reivindicar a recompensa VIP dentro de 3 dias, o
        otlotter.com considerará isso como uma renuncia voluntária à recompensa e
        não poderá ser reivindicada posteriormente.
      </p>
      <p class="content-c5-sign">
        4. Se um usuário se upgrade várias vezes consecutivamente sem
        reivindicar as recompensas, o otlotter.com tratá-lo como uma renuncia às
        recompensas e o usuário só poderá reivindicar a recompensa para a
        atualização mais recente.
      </p>
      <p class="content-c5-sign">
        5. Este evento é apenas para titulares de contas normais. É proibido
        participar por meio de métodos como alugar de contas, uso de plugins,
        apostas de diferentes locais, etc. Se tais métodos forem detectados, as
        recompensas serão canceladas e a conta poderá ser congelada ou colocada
        na lista negra. Qualquer atividade como escovação de ordens, arbitragem
        ou uso de meios técnicos como acordos de controle em grupo resultará na
        suspensão da conta.
      </p>`,
  bonus_txt39: `Reembolsos de Equipe`,
  bonus_txt40: `<p class="m-t-10">
          1. Sua equipe receberá uma recompensa de cashback todas as semanas.
        </p>
        <p class="m-t-10">
          2. O valor total das apostas da equipe é calculado de segunda-feira às 00:00 até domingo às 23:59.
        </p>
        <p class="m-t-10">
          3. Você pode resgatar a recompensa de cashback da sua equipe de segunda-feira às 00:00 até segunda-feira às 23:59.
        </p>
        <p class="m-t-10">
          4. O cashback da equipe é calculado multiplicando o valor total real das perdas da sua equipe pela porcentagem de cashback.
        </p>
        <p class="m-t-10">
          5. Se sua equipe não fizer nenhuma aposta durante o período de cashback ou se o valor total das vitórias da sua equipe for maior que as perdas totais da semana anterior, sua equipe não receberá o cashback.
        </p>
        <p class="m-t-10">
          6. O valor máximo de cashback por equipe por semana é de 100.000 BRL.
        </p>
        <p class="m-t-10">
          7. No entanto, antes de você poder sacar a recompensa de cashback da equipe, sua equipe precisa fazer pelo menos 3 rodadas de apostas com o valor recebido de cashback.
        </p>
        <p class="m-t-10">
          8. A decisão final sobre todos os assuntos relacionados ao cashback da equipe é de responsabilidade do otlotter.com.
        </p>`,
  bonus_txt41: `Regras de Recompensa Diária VIP`,
  bonus_txt42: `Após atingir o nível correspondente, se o valor da aposta válida for >=
        200.000 ou o valor do depósito >= 20.000 dentro de 2 dias, você pode
        resgatar a recompensa, que será emitida em tempo real para sua carteira
        na plataforma.`,
  bonus_txt43: `Taxa de Cashback VIP`,
  mine_txt: `Conta:`,
  mine_txt2: `Valor de crescimento necessário:`,
  mine_txt3: `Depósito Total:`,
  mine_txt4: `Tem certeza de que deseja sair?`,
  mine_txt5: `Detalhes da carteira`,
  mine_txt6: `Histórico de Jogos`,
  mine_txt7: `Compartilhar`,
  mine_txt8: `Nome da conta`,
  mine_txt9: `Alterar senha de login`,
  mine_txt10: `Alterar senha de saque`,
  mine_txt11: `Conta PIX`,
  mine_txt12: `Avatar`,
  mine_txt13: `Politica de Privacidade`,
  mine_txt14: `Sair`,
  recordOrder_title: 'Lista de Pedidos',
  recordOrder_txt: 'Emitindo para',
  recharge_success: 'Recarga bem-sucedida',
  order_reversed: 'Pedido estornado',
  mc_read_all: 'Marcar tudo como lido',
  mc_delete_read: 'Excluir lidas',
  mc_inbox: 'Caixa de Entrada',

  orderDetail_title: 'Detalhes do pedido',
  orderDetail_txt: 'Tipo de transação',
  orderDetail_txt2: 'Método de reembolso',
  orderDetail_txt3: 'Data do reembolso',
  orderDetail_txt4: 'Número do pedido',
  orderDetail_txt5: 'número da conta bancária',
  orderDetail_txt6: 'Observação',
  authName_title: 'Autenticação de Nome Real',
  authName_txt: 'Nome Real',
  authName_txt2: `Certifique-se de que o seu nome corresponda ao nome da conta bancária
        para garantir a segurança.`,
  authName_txt3: 'Digite seu nome',
  bankAdd_txt: 'Gerenciar Conta',
  setPassWord_title: 'Alterar senha de saque',
  setPassWord_txt: `Você é a primeira retirada, você precisa definir a senha de retirada
        primeiro`,
  setPassWord_txt2: `Defina sua senha de saque`,
  setPassWord_txt3: `senha antiga:`,
  setPassWord_txt4: `nova senha:`,
  setPassWord_txt5: `Lembrete caloroso: A senha de resgate é muito importante. Lembre-se de
        lembrá-la e guardá-la. Não conte a ninguém. Se ocorrer uma perda, os
        ativos não serão recuperados.`,
  setPassWord_txt6: `6 números`,
  setPassWord_txt7: `As senhas inseridas duas vezes são inconsistentes`,
  avatar_title: 'Selecionar Avatar',
  bank_title: `Cartão Bancário`,
  bank_txt: 'Remover este cartão bancário?',
  bank_txt2: `Senha de Retirada`,
  bank_empty: 'Nenhum cartão bancário',
  bank_empty_desc: 'Adicione um cartão bancário para saques',
  bank_add: 'Adicionar cartão',
  bank_pwd_ph: 'Digite a senha de retirada',
  billGame_title: `Registro de Jogos`,
  billGame_txt: `Jogo:`,
  billGame_txt2: `Bet:`,
  billGame_txt3: `Win:`,
  billGame_txt4: `Hoje`,
  billGame_txt5: `Ontem`,
  billGame_txt6: `Esta Semana`,
  billGame_txt7: `Semana passada`,
  billGame_txt8: `Este Mês`,
  billGame_txt9: `Mês passado`,
  billGame_txt10: `todos`,
  gameHall_txt: `Complete o primeiro depósito para entrar no jogo.`,
  gameHall_txt2: `Devido à manutenção do jogo por parte do fabricante, volte mais tarde.`,
  gameHall_txt3: `A funcionalidade do jogo foi desativada. Por favor, entre em contato com o suporte online para obter ajuda.`,
  gameHall_txt4: `Saldo insuficiente, por favor recarregue e continue.`,
  gameHall_txt5: `Are you sure you want to exit the current game?`,
  passwordLogin_title: `Alterar senha de login`,
  passwordLogin_txt: `Senha antiga`,
  passwordLogin_txt2: `Nova senha`,
  passwordLogin_txt3: `Senha de login`,
  passwordLogin_txt4: `Lembrando que a negligência na proteção da sua senha pode levar a perdas
        irreversíveis. Mantenha - a sempre confidencial e você estará garantindo
        a segurança contínua de suas informações.`,
  passwordLogin_txt5: `Digite a senha antiga.`,
  passwordLogin_txt6: `Digite a senha de login.`,
  passwordLogin_txt7: `A nova senha é a mesma da anterior.`,
  privacy_title: `Política de Privacidade`,
  privacy_txt: `<p class="m-t-20 f-t-16 f-b" >
        Política de Privacidade e Proteção de Dados Pessoais
      </p>

      <p class="font-color2" style="line-height: 20px; margin-top: 10px">
        1. Introdução:
      </p>
      <p class="font-color m-t-10" style="line-height: 20px">
        Na otlotter.com, nosso objetivo é proporcionar aos usuários a melhor
        experiência possível. Portanto, para oferecer serviços cada vez mais
        personalizados a você (nosso usuário), precisamos entender seus hábitos
        de jogo e interação. No entanto, a privacidade e a segurança de seus
        dados pessoais são sempre nossa maior prioridade. É por isso que
        desejamos explicar de forma transparente e detalhada como coletamos,
        armazenamos, compartilhamos e utilizamos seus dados pessoais, bem como
        esclarecer as opções de escolha e controle disponíveis para você ao
        decidir compartilhar tais dados pessoais. Este é o principal objetivo
        desta Política de Privacidade e Proteção de Dados Pessoais ("Política").
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        2. Sobre esta Política
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Esta Política descreve os detalhes-chave sobre a relação entre os dados
        pessoais dos usuários e a otlotter.com. Esta Política se aplica a todos os
        serviços da otlotter.com e a qualquer serviço relacionado (coletivamente
        referidos como "Serviços da otlotter.com"). Os termos que regem o uso dos
        Serviços da otlotter.com pelos usuários são definidos em nossos Termos e
        Condições.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Podemos desenvolver novos serviços ou oferecer serviços adicionais de
        vez em quando. Se o lançamento desses novos ou serviços adicionais
        resultar em alterações na forma como coletamos e processamos dados
        pessoais, forneceremos informações adicionais juntamente com termos ou
        políticas complementares. A menos que especificamente indicado, sempre
        que introduzirmos novos ou serviços adicionais, eles serão regidos por
        esta Política.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        O objetivo desta Política é:
      </p>

      <p class="font-color m-t-10" style="line-height: 20px">
        Garantir que os usuários estejam plenamente informados sobre os dados
        pessoais que coletamos sobre eles, por que coletamos e utilizamos esses
        dados e com quem os compartilhamos;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Explicar como utilizamos os dados pessoais compartilhados conosco pelos
        usuários para proporcionar uma boa experiência ao usar os serviços da
        otlotter.com;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Explicar aos usuários seus respectivos direitos e opções em relação aos
        dados pessoais que coletamos e processamos, e como protegemos sua
        privacidade.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Esperamos que esta Política ajude os usuários a entender nosso
        compromisso com sua privacidade. Se tiverem qualquer preocupação ou
        dúvida, consulte a Seção 14, "Contato", abaixo, para informações sobre
        como entrar em contato conosco.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Por outro lado, se os usuários não concordarem com o conteúdo desta
        Política, declaramos que os usuários têm a liberdade de decidir se usam
        e/ou continuam usando os serviços da otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direitos e Preferências do Usuário: Oferecendo-lhe Opções e Controle:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se ainda não souber, as leis da UE e do Brasil, nomeadamente o
        "Regulamento Geral de Proteção de Dados" (ou "RGPD") e a "Lei Geral de
        Proteção de Dados do Brasil" (ou "LGPD"), respectivamente, conferem a
        indivíduos certos direitos em relação aos seus dados pessoais. Conforme
        as disposições legais aplicáveis, sujeitas a quaisquer restrições nelas
        estabelecidas, os direitos conferidos aos indivíduos são os seguintes:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito de Acesso – O direito de ser informado e solicitar acesso aos
        dados pessoais que processamos sobre você;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito de Retificação – O direito de solicitar que corrijamos ou
        atualizemos dados pessoais que sejam imprecisos ou incompletos;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito à Exclusão – O direito de solicitar que excluamos seus dados
        pessoais de nossos bancos de dados;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito de Restrição – O direito de solicitar que interrompamos
        temporária ou permanentemente o processamento de todo ou parte de seus
        dados pessoais;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito de Oposição – O direito de se opor ao processamento de seus
        dados pessoais por razões relacionadas à sua situação específica em
        qualquer momento, o direito de se opor ao processamento de seus dados
        pessoais para fins de marketing direto;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito à Portabilidade dos Dados – O direito de solicitar uma cópia de
        seus dados pessoais em formato eletrônico e transmitir esses dados para
        serviços de terceiros;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Direito de Não Ser Submetido a Decisões Automáticas – O direito de não
        ser submetido a decisões baseadas exclusivamente em processamento
        automatizado, incluindo a criação de perfis, que o afetem
        significativamente de forma legal ou similar.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para permitir que os usuários exerçam facilmente esses direitos e
        registrem suas preferências em relação ao uso que a otlotter.com faz de seus
        dados pessoais, fornecemos as seguintes opções através das Configurações
        de Privacidade na página "Meu Perfil":
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        1. Controlar certas categorias de dados pessoais que processamos;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        2. Gerenciar os dados pessoais que você torna públicos;
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        3. Definir preferências de compartilhamento.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se enviarmos comunicações de marketing eletrônico com base em seu
        consentimento ou outra base legal aplicável, os usuários podem retirar
        seu consentimento ou se opor (opt-out) a qualquer momento, sem custo.
        Para isso, basta usar o link de cancelamento de inscrição no próprio
        e-mail para se retirar da lista de envio.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se tiver qualquer dúvida sobre sua privacidade, direitos ou como exercer
        tais direitos, deve entrar em contato com nosso Encarregado de Proteção
        de Dados enviando um e-mail para info@startechgame.com, e responderemos
        ao usuário relevante em tempo razoável após verificar sua identidade.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se não estiver satisfeito com a forma como tratamos seus dados pessoais,
        também pode apresentar uma queixa escrita à autoridade de proteção de
        dados em sua jurisdição.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        4. Como Coletamos os Dados Pessoais dos Usuários?
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Coletamos os dados pessoais dos usuários das seguintes formas:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Quando os usuários se registram para os serviços da otlotter.com: Após o
        registro, coletamos determinados dados pessoais, como, mas não se
        limitando a: endereço de e-mail, nome completo, gênero, país/região,
        endereço IP, dispositivo utilizado e seus identificadores, para que
        possam usar os serviços relevantes da otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Através do uso dos serviços da otlotter.com: Quando os usuários utilizam os
        serviços da otlotter.com, coletamos dados pessoais sobre seu uso dos
        serviços relevantes da otlotter.com, como jogos jogados, histórico de jogo,
        lista de dispositivos usados para acessar o serviço, apelido usado ao
        acessar de um único dispositivo, alterações nas posições de
        classificação, alterações nos saldos de pontos virtuais para cada
        usuário, endereço IP utilizado para acesso e outras informações
        necessárias para alcançar nossos objetivos comerciais. Por exemplo, os
        usuários também podem ocasionalmente nos fornecer dados pessoais
        adicionais ou conceder-nos permissão para coletar outros dados pessoais
        para oferecer mais funcionalidades ou recursos. Os dados pessoais
        coletados também nos permitem mitigar riscos relacionados aos usuários e
        serviços e/ou prevenir fraudes.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Através de terceiros – Também podemos receber dados pessoais
        relacionados aos usuários e suas atividades de terceiros (incluindo
        anunciantes e parceiros com os quais trabalhamos) para que possamos
        fornecer serviços da otlotter.com (consulte a Seção 7 "Compartilhamento de
        Dados Pessoais dos Usuários" abaixo). Se os usuários relevantes
        autorizarem o terceiro ou MEGA SLOTS a compartilhar tais dados, ou se a
        otlotter.com tiver um interesse legítimo em usar esses dados pessoais para
        fornecer serviços da otlotter.com, usaremos esses dados pessoais.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Como descrito abaixo, não coletaremos fotos dos usuários, localização
        geográfica exata de dispositivos móveis, dados de voz ou listas de
        contatos sem autorização prévia do usuário. Você sempre pode mudar de
        ideia e retirar seu consentimento.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        5. Quais Tipos de Dados Pessoais dos Usuários Coletamos?
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Na tabela abaixo, resumimos as categorias de dados pessoais dos usuários
        que coletamos e utilizamos:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Categoria de Dados Pessoais, Descrição da Categoria
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Informações de Registro de Conta, Estes são os dados pessoais fornecidos
        pelo usuário ou coletados por nós para que o usuário utilize os serviços
        da otlotter.com. Isso inclui o nome do usuário, documentos de identificação,
        endereço de e-mail, data de nascimento, gênero e endereço físico. Os
        usuários devem fornecer determinados dados pessoais ao criar uma conta.
        Os usuários também podem optar por fornecer dados pessoais adicionais
        para personalizar sua experiência.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Dados de Uso. Refere-se aos dados pessoais coletados quando os usuários
        utilizam os serviços da otlotter.com, que podem incluir: - Informações sobre
        o tipo de plano de serviço da otlotter.com. - Informações sobre as
        interações dos usuários com os serviços da otlotter.com, como jogos jogados,
        histórico de jogo, lista de dispositivos usados para acessar o serviço,
        histórico de apelidos usados para acessar de um único dispositivo,
        alterações nas posições de classificação, alterações nos saldos de
        pontos virtuais para cada usuário e interações com outros usuários da
        otlotter.com. - Isso também pode incluir informações sobre o uso de
        aplicativos de terceiros e qualquer anúncio que você receba. - Conteúdo
        dos usuários que eles publicam na otlotter.com (conforme definido nos Termos
        e Condições), incluindo mensagens enviadas e/ou recebidas através da
        otlotter.com e interações com o suporte ao cliente da otlotter.com. - Dados
        técnicos, que podem incluir informações de URL, dados de cookie,
        endereço IP do usuário, dispositivos usados para acessar os serviços da
        otlotter.com, identificadores únicos de dispositivo, atributos de
        dispositivo e tipos de conexão de rede (Wi-Fi, 3G, LTE, Bluetooth,
        etc.), provedor de rede, desempenho de rede e dispositivo, navegador,
        idioma, informações de gerenciamento de direitos digitais, sistema
        operacional e versão do aplicativo otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Dados Pessoais Coletados com Seu Autorização Permitem-Nos Fornecer
        Funcionalidades ou Recursos Adicionais:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Categoria de Dados Pessoais | Descrição da Categoria
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Dados Móveis Opcionais <br />Além dos dados móveis que coletamos para
        fornecer serviços da otlotter.com (como descrito acima), os usuários podem
        optar por autorizar-nos a coletar dados pessoais adicionais de seus
        dispositivos móveis para que possamos fornecer os seguintes recursos e
        funcionalidades que aprimoram sua experiência com os serviços MEGA
        SLOTS.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Sem consentimento do usuário, não coletaremos nenhum dos seguintes dados
        pessoais:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Fotos do Usuário – Se os usuários nos permitirem acesso às suas fotos ou
        câmera, coletaremos apenas as imagens que eles escolherem
        especificamente compartilhar conosco e os metadados associados a essas
        imagens, como tipo de arquivo e tamanho da imagem. Nunca faremos upload
        ou importaremos a biblioteca inteira de fotos ou rolos de câmera do
        usuário.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Localização Geográfica Exata do Dispositivo Móvel do Usuário – Se os
        usuários autorizarem o acesso a localizações específicas, podemos usar o
        GPS ou Bluetooth do usuário para fornecer funcionalidades dos serviços
        otlotter.com que requerem dados de localização exata. Observe que isso não
        inclui o endereço IP do usuário. Usamos o endereço IP do usuário para
        determinar uma localização geográfica não exata, como o país/região em
        que ele se encontra, para fins de cumprimento de nossos Termos e
        Condições.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Lista de Contatos do Usuário – Se os usuários autorizarem o acesso à sua
        lista de contatos, podemos revisar a lista de contatos armazenada em
        seus dispositivos para ajudá-los a encontrar amigos que estejam usando
        MEGA SLOTS.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Informações de Pagamento
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se os usuários se registrarem para um período de teste ou realizarem
        qualquer compra através dos serviços da otlotter.com (conforme definido nos
        Termos e Condições), podemos coletar esses dados pessoais. Os dados
        efetivamente coletados podem variar dependendo do método de pagamento,
        mas podem incluir o seguinte:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Nome<br />
        Data de nascimento<br />
        ID<br />
        Tipo de débito ou cartão de crédito, data de validade e alguns dígitos
        do número do cartão<br />
        Endereço físico<br />
        Número de telefone<br />
        Histórico de transações do usuário<br />
        Se os usuários optarem por pagar por fatura, forneceremos seus dados
        pessoais ao nosso processador de pagamentos para consultas de crédito e
        para enviar faturas ao usuário.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Ofertas Especiais, Concursos e Sorteios
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Estes dados pessoais são usados para permitir que os usuários se
        registrem e participem de ofertas especiais. Os dados pessoais coletados
        podem variar dependendo da oferta especial.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Dados de Marketing
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Estes dados pessoais são usados para permitir que a otlotter.com e seus
        parceiros/prestadores de serviços enviem informações de marketing aos
        usuários:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Por e-mail<br />
        Ao usar os serviços da otlotter.com<br />
        Diretamente de terceiros.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        6. Para Quais Finalidades Usamos os Dados Pessoais dos Usuários?
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Quando os usuários utilizam os serviços da otlotter.com ou interagem com
        eles, usamos várias tecnologias para processar os dados pessoais
        coletados por várias razões. Na tabela abaixo, listamos as razões pelas
        quais processamos os dados pessoais dos usuários, as bases legais para
        nossas ações e as categorias de dados pessoais (conforme definido na
        Seção 5 "Quais Tipos de Dados Pessoais Coletamos Sobre os Usuários?")
        usados para as seguintes finalidades:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Explicação das razões para o processamento de dados pessoais pela
        otlotter.com ("Finalidades de Processamento")<br />
        Base Legal para a Finalidade de Processamento<br />
        Categorias de Dados Pessoais Usados para a Finalidade de Processamento
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para fornecer, personalizar e aprimorar a experiência do usuário com o
        serviço otlotter.com e outros serviços e produtos fornecidos pela otlotter.com,
        como oferecer conteúdo personalizado, adaptado ou baseado em
        localização, e recomendações, recursos e anúncios (incluindo produtos e
        serviços de terceiros) dentro ou fora da otlotter.com.<br />
        Execução de contrato<br />
        Dados de registro de conta, dados de uso de serviço e, se aplicável,
        dados móveis opcionais
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para garantir a integridade dos sistemas de classificação fornecidos e
        reduzir fraudes e conluio relacionados aos usuários no ambiente de
        entretenimento da otlotter.com. Execução de contrato, interesses legítimos
        Dados de registro de conta, dados de uso de serviço
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para entender como os usuários acessam e usam o serviço otlotter.com,
        visando garantir a funcionalidade técnica dos serviços otlotter.com,
        desenvolver novos produtos e serviços e analisar o uso dos usuários dos
        serviços otlotter.com, incluindo suas interações com o aplicativo, bem como
        publicidade, produtos e serviços relacionados ou fornecidos através de
        MEGA SLOTS.<br />
        Execução de contrato, interesses legítimos Dados de registro de conta,
        dados de uso de serviço
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para estabelecer comunicação com os usuários para fins relacionados ao
        serviço otlotter.com. Execução de contrato, interesses legítimos Dados de
        registro de conta, dados de uso de serviço
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para processar pagamentos dos usuários e prevenir ou identificar
        atividades fraudulentas, incluindo pagamentos fraudulentos e uso
        fraudulento dos serviços MEGA SLOTS.<br />
        Execução de contrato, obrigações legais, interesses legítimos<br />
        Dados de registro de conta, dados de uso de serviço, informações de
        pagamento
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para comunicar diretamente com os usuários ou através de nossos
        parceiros para os seguintes fins: Execução de contrato, interesses
        legítimos Dados de registro de conta, dados de uso de serviço,
        informações de pagamento
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Marketing<br />
        Pesquisas<br />
        Participação em concursos e ofertas especiais
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Conforme qualquer autorização que o usuário possa ter concedido à
        otlotter.com (como através das configurações de privacidade), por e-mail,
        notificações ou outras mensagens.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Autorização<br />
        Interesses legítimos
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Dados de concursos e sorteios<br />
        Dados de marketing<br />
        Para fornecer aos usuários funcionalidades, informações, anúncios ou
        conteúdo com base na localização exata do usuário.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Autorização<br />
        Dados móveis opcionais
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        As finalidades para as quais usamos informações anonimizadas e agregadas
        incluem testar nossos sistemas de TI, pesquisa, análise de dados,
        criação de modelos de marketing e promoção, aprimoramento dos serviços
        otlotter.com e desenvolvimento de novas funcionalidades e recursos para os
        serviços otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        7. Compartilhamento de Dados Pessoais dos Usuários:<br />
        Listamos abaixo as categorias de destinatários que podem receber dados
        pessoais coletados ou gerados através do uso dos serviços MEGA SLOTS
        (conforme aplicável):
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Informações Públicas
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Os seguintes dados pessoais do usuário estarão sempre disponíveis
        publicamente nos serviços da otlotter.com: apelido do usuário, imagem de
        perfil, informações de desempenho em jogos e data de criação da conta,
        bem como outros dados pessoais que podem ser verificados na página de
        perfil do usuário.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Dados Pessoais Compartilhados pelo Usuário
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Os seguintes dados pessoais serão compartilhados apenas com as
        categorias de destinatários listadas abaixo se:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        O usuário selecionar um recurso específico dos serviços da otlotter.com que
        requer o compartilhamento de dados pessoais para usar o recurso
        corretamente. <br />O usuário autorizar explicitamente o
        compartilhamento de dados pessoais, como selecionando as configurações
        apropriadas nas configurações de privacidade dos serviços da
        otlotter.com.<br />
        Categoria de Conteúdo<br />
        Razão de Compartilhamento
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Aplicativos de terceiros usados para fazer login no MEGA SLOTS<br />
        Ao acessar sua conta otlotter.com de um aplicativo de terceiro (como um
        aplicativo de mídia social), a otlotter.com pode compartilhar dados para
        vincular a conta do usuário em ambos os registros, ou seja, a rede
        otlotter.com e qualquer terceiro.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se o usuário associar suas credenciais da conta MEGA SLOTS a um
        aplicativo de terceiro, tal aplicativo de terceiro pode ter acesso a
        determinados dados de uso do serviço, conteúdo armazenado e atividades.
        Antes de se conectar a um aplicativo de terceiro, o usuário será
        informado de que seus dados pessoais serão compartilhados com e/ou
        acessíveis por tais aplicativos de terceiros.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Comunidade <br />Quando um usuário se junta à comunidade otlotter.com, deve
        usar o mesmo apelido que o de sua conta. Tais apelidos de usuário serão
        exibidos publicamente para qualquer pessoa que acesse a área da
        comunidade otlotter.com, juntamente com qualquer pergunta, comentário e
        outro conteúdo que escolham publicar ou tornar público através das
        configurações de privacidade dos serviços da otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para obter informações mais detalhadas sobre informações públicas e o
        conteúdo que os usuários compartilham com terceiros, consulte a Seção 3,
        "Direitos e Preferências do Usuário: Oferecendo-lhe Opções e Controle"
        nesta política e as configurações de privacidade.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Informações que Podemos Compartilhar
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Categoria de Conteúdo<br />
        Razão de Compartilhamento
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Provedores de serviços e outras partes Usamos provedores de serviços
        técnicos para a infraestrutura necessária para operar os serviços da
        otlotter.com, especialmente aqueles que hospedam, armazenam, gerenciam e
        mantêm o aplicativo otlotter.com, seu conteúdo e os dados que processamos.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Usamos provedores de serviços técnicos para nos ajudar a nos comunicar
        com os usuários, conforme descrito na Seção 6 desta política.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Também usamos parceiros de marketing e publicidade para exibir conteúdo
        mais personalizado ou para nos ajudar a entender como os usuários estão
        usando os serviços da otlotter.com e fornecer melhores serviços. Também
        podemos compartilhar dados pessoais com certos parceiros de marketing e
        publicidade para enviar informações promocionais sobre a otlotter.com aos
        usuários.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Além disso, usamos parceiros de pagamento; no entanto, nesse caso, não
        armazenamos ou compartilhamos dados de cartão de crédito ou outros
        métodos de pagamento, e todos os dados relacionados a pagamentos
        inseridos em nossas páginas são criptografados e enviados para a API de
        pagamento relevante.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Parceiros da otlotter.com<br />
        Se o usuário acessar os serviços da otlotter.com através de uma oferta
        recebida de um terceiro (como sua operadora de rede móvel),
        compartilharemos dados pessoais sobre seu uso dos serviços da otlotter.com,
        como se e até que ponto usaram a oferta, se ativaram sua conta MEGA
        SLOTS ou se estão usando ativamente os serviços da otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Também compartilhamos dados pessoais dos usuários em formato anonimizado
        com parceiros de marketing que nos ajudam com promoções e com
        anunciantes que nos permitem oferecer serviços gratuitos.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Conformidade com Autoridades Legais e de Proteção de Dados <br />Quando
        acreditamos de boa fé que é necessário cumprir obrigações legais
        aplicáveis ou responder a processos legais válidos (como mandados de
        busca, ordens judiciais ou citações), compartilharemos dados pessoais
        dos usuários.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se acreditamos sinceramente que é necessário para nossos interesses
        legítimos ou os de terceiros, e para segurança nacional, aplicação da
        lei, litígios, investigações criminais, proteção da segurança de
        qualquer pessoa ou para evitar morte ou dano corporal iminente, também
        podemos compartilhar dados pessoais dos usuários, desde que consideremos
        que tais interesses não prevalecem sobre a necessidade de proteger os
        dados pessoais dos usuários e seus direitos e liberdades fundamentais.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Compradores Empresariais<br />
        Quando vendemos ou negociamos a venda de nosso<br />
        negócio para um comprador ou possível comprador, compartilharemos dados
        pessoais dos usuários.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Nesses casos, a otlotter.com continuará a garantir a confidencialidade dos
        dados pessoais dos usuários, e notificaremos os usuários antes de
        transferir seus dados pessoais para o comprador ou antes de cumprir uma
        política de privacidade diferente.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        8. Retenção e Exclusão de Dados: <br />Retteremos dados pessoais dos
        usuários conforme necessário para fornecer os serviços da otlotter.com e
        para fins legítimos e necessários de negócios, como manter o desempenho
        dos serviços otlotter.com, tomar decisões de negócios sobre recursos e
        ofertas com base em dados, cumprir nossas obrigações legais e resolver
        disputas. Retaremos alguns dados pessoais obtidos dos usuários enquanto
        eles permanecerem usuários dos serviços da otlotter.com. Por exemplo,
        retaremos histórico de uso e histórico de compras, perfil, posição de
        classificação, registros de crédito e outras informações de conta.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        A pedido do usuário, excluiremos ou anonimizaremos seus dados pessoais
        de modo que o usuário não possa ser identificado, exceto se a lei
        permitir ou exigir a retenção de determinados dados pessoais durante o
        processamento, incluindo nas seguintes situações:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Se houver questões pendentes na conta do usuário, como créditos
        pendentes ou queixas ou disputas não resolvidas, retaremos todos os
        dados pessoais necessários até que a questão seja resolvida.<br />Se
        precisarmos reter dados pessoais para cumprir nossas obrigações legais,
        fiscais, de auditoria e contabilidade, retaremos todos os dados pessoais
        necessários pelo período exigido pela lei aplicável.<br />
        Sempre que acreditarmos ser necessário para manter nossos interesses
        legítimos de negócios, como prevenir fraudes ou garantir a segurança de
        nossos usuários.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        9. Transferência para Outros Países: A otlotter.com compartilha alguns dos
        dados pessoais obtidos de usuários globais com UNITED JOY LLP, sediada
        em Londres, Reino Unido, para realizar as atividades especificadas nesta
        política.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        A otlotter.com também pode subcontratar serviços ou compartilhar dados
        pessoais obtidos de usuários com terceiros localizados em países fora do
        país de residência do usuário. Portanto, os dados pessoais obtidos dos
        usuários podem estar sujeitos a leis de privacidade que diferem daquelas
        em seu país de residência.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Por exemplo, dados pessoais coletados na UE e na Suíça podem ser
        transferidos e processados por terceiros localizados fora da UE e da
        Suíça. Nesses casos, a otlotter.com garantirá que a transferência de dados
        pessoais dos usuários esteja em conformidade com as leis de privacidade
        aplicáveis e, em particular, garanta que medidas contratuais, técnicas e
        organizacionais apropriadas estejam em vigor, como as cláusulas
        contratuais padrão aprovadas pela Comissão Europeia.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Para obter mais informações sobre as medidas de segurança que usamos
        para proteger os dados pessoais dos usuários, consulte a Seção 11,
        "Garantindo a Segurança dos Dados Pessoais dos Usuários".
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        10. URLs:<br />
        Podemos exibir anúncios de terceiros e outro conteúdo, como URLs que
        redirecionam para sites de terceiros. Não temos controle sobre as
        práticas de privacidade ou conteúdo de terceiros e não nos
        responsabilizamos por eles. Se os usuários clicarem em anúncios ou URLs
        de terceiros, devem estar cientes de que sairão dos serviços da otlotter.com
        e que qualquer dado pessoal que fornecerem não estará sujeito a esta
        política. Os usuários devem ler as políticas de privacidade relevantes
        para entender como seus dados pessoais serão coletados e processados.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        11. Garantindo a Segurança dos Dados Pessoais dos Usuários: Estamos
        comprometidos em proteger os dados pessoais dos usuários.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Implementamos medidas técnicas e organizacionais para ajudar a garantir
        a segurança dos dados pessoais obtidos dos usuários, como a criação de
        apelidos, criptografia e políticas de acesso e retenção para impedir o
        acesso não autorizado e a retenção desnecessária de dados pessoais em
        nossos sistemas. No entanto, os usuários devem estar cientes de que
        nenhum sistema é completamente seguro.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        As senhas podem proteger as contas dos usuários, portanto, incentivamos
        os usuários a usar senhas únicas e confiáveis, limitar o acesso a
        computadores, navegadores e outros dispositivos considerados seguros
        (confiáveis) e fazer logout após usar os serviços da otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        12. Crianças: <br />Crianças com Idade entre 13 e 18 Anos<br />Recomendamos
        que menores com mais de 13 anos obtenham consentimento dos pais antes de
        enviar qualquer informação sobre si mesmos pela internet.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Os usuários podem usar sua conta apenas para fins de entretenimento não
        comerciais. Os usuários não podem usar este serviço para qualquer outro
        fim, como coletar fichas de várias contas ou de qualquer outra maneira.
        Os usuários não podem usar sua conta para qualquer atividade ilegal.
        <br />Os usuários não podem enviar mensagens repetidas (spam), e-mails
        não solicitados, anúncios ou solicitações usando sua conta. <br />Os
        usuários não podem usar linguagem profana, discriminatória ou maliciosa
        de qualquer forma, incluindo em sua imagem de perfil.<br />Os usuários
        não podem usar sua conta para trapacear ou hackear o jogo. Perder
        intencionalmente para transferir fichas é facilmente rastreável, e esse
        comportamento resultará na confisco de suas fichas e em um banimento.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        7. Os usuários não podem sublicenciar, alugar, vender, dar, vender ou de
        outra forma transferir total ou parcialmente sua conta ou itens virtuais
        relacionados a qualquer pessoa sem a permissão escrita da otlotter.com.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        8. Os usuários não podem comprar ou adquirir fichas, bônus ou qualquer
        outro item virtual de fontes não autorizadas (como links de origem
        desconhecida ou pessoas prometendo fichas grátis, etc.).
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        9. Cada rede social permite que os usuários usem o serviço com uma única
        conta. Além disso, os usuários não podem usar várias contas para tentar
        acumular fichas grátis. Esse comportamento pode ser facilmente detectado
        e resultará na suspensão e/ou banimento de todas as suas contas.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        10. Os usuários não podem explorar scripts ou processos manuais para
        abusar da acumulação de fichas grátis.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        11. Se um usuário tiver sido excluído ou banido de usar o serviço, o
        usuário não pode usar qualquer serviço ou criar contas ou usar qualquer
        conta.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        12. Se não concordar com os termos de serviço, os usuários não podem
        usar qualquer jogo ou serviço da otlotter.com, e a permissão do usuário para
        usar o serviço será imediatamente rescindida.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        13. Os usuários não têm o direito de:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Excluir qualquer informação ou conteúdo relacionado a direitos autorais
        no software otlotter.com e outras cópias; Reengenharia, desmontagem,
        descompilação ou tentativa de copiar ou alterar o software do jogo MEGA
        SLOTS por qualquer motivo; Usar, copiar, modificar, vincular,
        republicar, compilar, publicar, transmitir, criar sites espelho ou usar
        o jogo otlotter.com para esses fins sem o consentimento prévio da otlotter.com,
        ou desenvolver produtos, obras ou serviços derivados relacionados ao
        software.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        14. Alterações nesta Política de Privacidade:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Podemos alterar esta política de vez em quando.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Quando realizamos alterações significativas nesta política, elaboraremos
        comunicações apropriadas e notáveis, como exibir avisos proeminentes
        sobre os serviços MEGA SLOTS ou enviar e-mails aos usuários, dependendo
        das circunstâncias. Também podemos enviar comunicações aos usuários com
        antecedência.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Portanto, os usuários devem ler cuidadosamente todas as comunicações.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        15. Contate-nos:
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        Obrigado por ler nossa política de privacidade. Se tiver qualquer dúvida
        sobre esta política, envie um e-mail para email.com para entrar em
        contato com nosso Encarregado de Proteção de Dados.Responderemos em
        tempo razoável após verificar a identidade do usuário relevante.
      </p>

      <p class="font-color2 m-t-10" style="line-height: 20px">
        A otlotter.com é responsável pelo processamento de dados pessoais dos
        usuários de acordo com esta política.
      </p>`,
  profile_title: `Informações da conta`,
  vip_txt: `Valor de crescimento necessário:`,
  vip_txt2: `Depósito Total:`,
  vip_txt3: `Lista de niveis VIP`,
  vip_txt4: `Nível`,
  vip_txt5: `Valor da<br />
          recarga`,
  vip_txt6: `Bônus de<br />
          atualização`,
  vip_txt7: `Recompensas<br />
          as diárias`,
  vip_txt8: `Bônus<br />
          Mensal`,
  ResherContent_txt: `Show`,
  ResherContent_txt2: `of`,
  ResherContent_txt3: `games`,
  ResherContent_txt4: `Ver Mais`,
  ResherContent_txt5: `Não há mais`,
  BankInfo_txt: `Saldo da Conta:`,
  BankInfo_txt2: `Volume de apostas necessário para atingir`,
  BankInfo_txt_withdrawable: `Valor disponível para saque:`,
  BankInfo_txt3: `Ainda preciso fazer uma aposta`,
  BankInfo_txt4: `Pode ser retirado`,
  BankInfo_txt5: `Retirada Padrão`,
  BankInfo_txt6: `Adicionar Conta`,
  BankInfo_txt7: `Todus`,
  BankInfo_txt8: `Senha de Saque`,
  BankInfo_txt9: `Por favor, insira o valor do saque.`,
  BankInfo_txt10: `Saldo insuficiente para saque`,
  BankInfo_txt11: `Intervalo de valor de saque inválido`,
  BankInfo_txt12: `Gerenciar Conta`,
  BankInfo_txt13: `Adicionar`,
  BankInfo_txt14: `É necessário atualizar para VIP2 para adicionar mais.`,
  BankInfo_txt15: `Por favor, insira seu CPF.`,
  BankInfo_txt16: `Por favor, insira a conta Pix`,
  ActivityPopup_txt: `Benefícios para novos jogadores`,
  ActivityPopup_txt2: `Registe uma conta`,
  ActivityPopup_txt3: `Bonus R$35`,
  ActivityPopup_txt4: `Bonus R$57`,
  ActivityPopup_txt5: `Vá`,
  ActivityPopup_txt6: `Não mostrar novamente hoje`,
  ActivityPopup_txt7: `Nunca perguntar novamente`,
  login_txt: `Número de telefone`,
  login_txt2: `Registre sua conta`,
  login_txt3: `Login`,
  login_txt4: `Senha`,
  login_txt5: `Força`,
  login_txt6: `Confirmar senha`,
  login_txt7: `Tenho 18 anos, li e concordo com`,
  login_txt8: `《Contrato do usuário》`,
  login_txt9: `Sobre nós`,
  login_txt10: `Registra uma Conta`,
  login_txt11: `Login Agora`,
  login_txt12: `Outros métodos de início de sessão`,
  login_txt13: `'Verificação bem-sucedida!'`,
  login_txt14: `'Verificação falhou, tente novamente'`,
  login_txt15: `'Arraste o bloco para completar o quebra-cabeça'`,
  login_txt16: `O nome de usuário não pode ter menos de 6 caracteres`,
  login_txt17: `A senha deve ter entre 6-16 caracteres`,
  login_txt18: `a senha repetida não confere`,
  login_txt19: `Por favor, insira o conteúdo`,
  login_txt20: `O nome de usuário não pode ter menos de 6 caracteres`,
  login_txt21: `A senha deve ter entre 6-16 caracteres`,
  login_txt22: `Concordo com os termos e política de privacidade`,
  share_txt: `Clique para copiar o link de convite`,
  share_txt2: `Compartilhar link via aplicativos soclals`,
  share_txt3: `Rede do Agente`,
  share_txt4: `Perf. Total 8500 Comissão total`,
  share_txt5: `225`,
  share_txt6: `Perf.5500 do Submarino`,
  share_txt7: `Comissão 3% Comissão direta`,
  share_txt8: `165`,
  share_txt9: `Outros' Perf. 3.000`,
  share_txt10: `Diferença de nível 2% Outras comissões`,
  share_txt11: `60`,
  share_txt12: `<p class="f-t-16 f-w font-color2">Duração:</p>
          <p class="m-t-10 font-color">
            De agora até uma data final anunciada posteriormente.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Recompensas de Indicação direta:
          </p>
          <p class="m-t-10 font-color">
            Durante o evento, para cada convite bem-sucedido de um usuário
            válido, o referenciador receberá diretamente uma recompensa de 10
            Reais, sem quaisquer restrições, e a recompensa pode ser retirada
            imediatamente.
          </p>
          <p class="m-t-10 font-color">
            Definição de usuário válido: O usuário convidado conclui um
            depósito.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Exemplo:</p>
          <p class="m-t-10 font-color">
            a. O usuário A convida B1, B2 e B3; A receberá uma recompensa de 10
            × 3 = 30 Reais.
          </p>
          <p class="m-t-10 font-color">
            b. B1 convida C1 e C2; B1 receberá uma recompensa de 10 × 2 = 20
            Reais.
          </p>
          <p class="m-t-10 font-color">
            c. B3 convida C3; B3 receberá uma recompensa de 10 × 1 = 10 Reais.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Bônus de comissão de apostas adicional:
          </p>
          <p class="m-t-10 font-color">
            O referenciador também pode receber uma certa porcentagem de
            recompensas adicionais com base no valor efetivo das apostas dos
            usuários convidados.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Taxa de comissão:</p>
          <p class="m-t-10 font-color">
            Se o valor efetivo da aposta estiver entre 0 e 100 Reais, a taxa de
            comissão será de 1% (ou seja, recompensa de 1 Real para cada aposta
            de 100 Reais).
          </p>
          <p class="font-color">
            Se o valor da aposta válida exceder 100 Reais, a taxa de comissão
            será de 3% (ou seja, recompensa de 3 Reais para cada aposta de 100
            Reais).
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Suposições:</p>
          <p class="m-t-10 font-color">
            O valor efetivo da aposta para B1 é de 50 Reais,
          </p>
          <p class="font-color">
            O valor efetivo da aposta para B2 é de 300 Reais,
          </p>
          <p class="font-color">
            O valor efetivo da aposta para B3 é de 20 Reais,
          </p>
          <p class="font-color">
            O valor efetivo da aposta para C1 é de 10 Reais,
          </p>
          <p class="font-color">
            O valor efetivo da aposta para C2 é de 20 Reais,
          </p>
          <p class="font-color">
            O valor efetivo da aposta para C3 é de 200 Reais.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            A comissão é calculada da seguinte forma:
          </p>
          <p class="m-t-10 font-color">
            Comissão B1 (contribuição direta de C1 e C2) = (10 + 20) × 1% = 0.3
            Real.
          </p>
          <p class="font-color">
            Comissão do B2 (sem subordinados) = (0 + 0) × 1% = 0 Real.
          </p>
          <p class="font-color">
            Comissão do B3 (contribuição direta do C3) = 200 × 3% = 6 Reais.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Comissão de A (a partir de contribuições dos subordinados diretos
            B1, B2, B3 e outros subordinados C1, C2, C3):
          </p>
          <p class="m-t-10 font-color">
            (1) Comissão direta de A (contribuições diretas de B1, B2 e B3) =
            (50 + 300 + 20) × 3% = 11,1 Reais.
          </p>
          <p class="font-color">
            (2) Outra comissão de A (contribuições de C1 e C2) = (10 + 20) × 2%
            = 0,6 Real.
          </p>
          <p class="font-color">
            (3) Comissão total de A (direita + outros) = 11,1 + 0,6 = 11,7
            Reais.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Descrição da estrutura da equipe:
          </p>
          <p class="m-t-10 font-color">
            (1) Equipe direta refere-se aos subordinados recrutados diretamente
            por A, ou seja, equipe que tem uma relação direta com A.
          </p>
          <p class="font-color">
            (2) Outras equipes: refere-se aos subordinados recrutados pelos
            subordinados de A, ou seja, equipes que não têm relação direta com A
            (como subordinados de subordinados, subordinados de subordinados de
            subordinados, etc.).
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(3) Descrição de A:</p>
          <p class="m-t-10 font-color">
            O desempenho direto de A é de 370 Reais, o outro desempenho é de 30
            Reais (principalmente do forte desempenho de C3), o desempenho total
            é de 400 Reais e a taxa de comissão correspondente é de 370*3%+30*2%
            = 11,7.
          </p>
          <p class="font-color">
            Como o desempenho total do B1 é de 30 Reais, ele só resulta de uma
            taxa de comissão de 1%, eliminando o desempenho direto do A é de 370
            Reais, e ele resulta de uma taxa de comissão de 3%. O restante é de
            apenas 30 Reais, que vem do B1. Portanto, há uma diferença de nível
            de 2% entre A e B1.
          </p>
          <p class="font-color">
            Essa diferença é contribuída para A por C1 e C2, ou seja: (10 + 20)
            × 2% = 0,6 Real.
          </p>
          <p class="font-color">
            Não há diferença de nível entre A e B3, então C3 não contribui com
            comissão para A.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(4) Descrição de B1:</p>
          <p class="m-t-10 font-color">
            B1 tem subordinados C1 e C2, com desempenho direto de 30 Reais e
            taxa de comissão correspondente de 1%.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(5) Descrição de B2:</p>
          <p class="m-t-10 font-color">
            O B2 não pode recrutar subordinados e, portanto, não tem renda.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(6) Descrição B3:</p>
          <p class="m-t-10 font-color">
            Embora B3 tenha ingressado mais tarde e seja subordinado de A, seu
            subordinado C3 teve um desempenho forte, com vendas diretas de RMB
            200, permitindo que B3 desfrutasse diretamente de uma alta taxa de
            comissão de 3%.
          </p>`,
  share_txt13: `Regras de liquidação da plataforma otlotter.com`,
  share_txt14: `As recompensas por convite e reembolsos de apostas são emitidos em
          tempo real. Clique em 'Convite Diário' para ver os detalhes da
          comissão.`,
  share_txt15: `Declaração Especial:`,
  share_txt16: `Para garantir a justiça na plataforma, políticas contra trapaças são
          aplicadas. Usuários que trapacearem serão permanentemente banidos,
          fundos obtidos ilegalmente serão congelados e a responsabilidade legal
          será perguida.`,
  share_txt17: `Data summary`,
  share_txt18: `Subordinados`,
  share_txt19: `diretos`,
  share_txt20: `Número de cobranças`,
  share_txt21: `pela primeira vez`,
  share_txt22: `O valor do `,
  share_txt23: `primeiro depósito`,
  share_txt24: `Revindicação total de`,
  share_txt25: `subs diretos`,
  share_txt26: `Total de apostas`,
  share_txt27: `válidas do sub direto`,
  share_txt28: `<p>Novos<br/> subordinados</p>`,
  share_txt29: `<p>Valor do primeiro <br/>depósito</p>`,
  share_txt30: `<p>Número de <br/> jogadores do<br/>primeiro depósito</p>`,
  share_txt31: `<p>Valor do depósito</p>`,
  share_txt32: `<p>Número de <br/>depósitos</p>`,
  share_txt33: `<p>Apostas Válidas</p>`,
  share_txt34: `Deposit amount: `,
  share_txt35: `Status: `,
  share_txt36: `His subordinates: `,
  share_txt37: `Valid Bets: `,
  share_txt38: `Login date: `,
  LuckyRoulette_txt: `Ganho`,
  LuckyRoulette_txt2: `Alegar`,
  LuckyRoulette_txt3: `Redefinir depósitos`,
  LuckyRoulette_txt4: `Ganhe ≥ 100 para recaber`,
  LuckyRoulette_txt5: `empate tempos`,
  LuckyRoulette_txt6: `restantes`,
  LuckyRoulette_txt7: `Promover 10 subordinados para obter 1 chance de empate`,
  LuckyRoulette_txt8: `Compartilhar`,
  LuckyRoulette_txt9: `O login bem-sucedido do subordinado promovido é considerado
                  válido, atualmente`,
  LuckyRoulette_txt10: `pessoas são válidas`,
  LuckyRoulette_txt11: `
                      <p class="m-t-10">
                        1. Durante o período da atividade, cada membro pode
                        ganhar 1 oportunidade de loteria carrossel, e ele pode
                        ganhar até 100,00 de bônus;
                      </p>
                      <p class="m-t-10">
                        2. Após completar a tarefa correspondente, você pode
                        obter 1 oportunidade de loteria. Após o número de sortes
                        de loteria ser usado, você pode continuar a completar a
                        tarefa e obter 1 oportunidade de loteria;
                      </p>
                      <p class="m-t-10">
                        3. Redefinição de prêmios diariamente, concluído missões
                        para reivindicar;
                      </p>
                      <p class="m-t-10">
                        4. A vencedora de recompensas só pode ser recebida
                        manualmente nas plataformas NPC Android_H5, iOS_H5,
                        Android_app, iOS_app;
                      </p>
                      <p class="m-t-10">
                        5. Após 1 dia ATT e o final de cada ciclo, as
                        recompensas recebidas expiram e são canceladas
                        diretamente;
                      </p>
                      <p class="m-t-10">
                        6. O bônus (excluindo capital) concedido neste evento
                        requer 1 vez de apostas válidas para ser retirado. A
                        aposta não se limita às plataformas de jogos;
                      </p>
                      <p class="m-t-10">
                        7. Este evento é apenas para as operações manuais
                        normais do proprietário da conta, qualquer uso de
                        software de trapaça, bots, jogos de azar entre contas
                        diferentes, manipulação mútua, arbitragem, APIs,
                        protocolos, exploração de vulnerabilidades, controle de
                        grupo ou outros meios técnicos são proibidos, caso
                        contrário, as recompensas podem ser canceladas ou
                        deduzidas, ou as contas podem ser congeladas ou até
                        mesmo colocadas na lista negra;
                      </p>
                      <p class="m-t-10">
                        8. Para evitar divergências na compreensão do texto, a
                        plataforma reserva-se o direito de interpretação final
                        deste evento.
                      </p>`,
  LuckyRoulette_txt12: `Parabéns por ganhar`,
  LuckyRoulette_txt13: `,que podem ser sacado por apenas`,
  LuckyRoulette_txt14: `. Convide`,
  LuckyRoulette_txt15: `amigos para
        completar o registro para ajudar você, e você pode resgatá-lo quando
        gastar`,
  RechargeCont_txt: `Registro de recarga`,
  RechargeCont_txt2: `Depósito on-line`,
  RechargeCont_txt3: `Os membros podem receber os bônus correspondentes apenas depois de
            depositarem o montante recomendado. O bónus adicional e o bónus de
            depósito podem ser acumulados e oferecidos`,
  RechargeCont_txt4: `Bônus pode ser resgatado após 1x faturamento`,
  RechargeCont_txt5: `Detalhes adicionais do evento de bónus`,
  RechargeCont_txt6: `First deposit,O valor mínimo para presente é`,
  RechargeCont_txt7: `Depósitos podem obter até 10% de bônus.`,
  RechargeCont_txt8: `Intervalo de valor de recarga incorreto.`,
  common_txt: `Nível Atual`,
  common_txt2: `Critérios de Promoção`,
  common_txt3: `Depósito Requerido:`,
  common_txt4: `Lista de níveis VIP`,
  common_txt5: `Ver Mais`,
  common_txt6: `Em andamento`,
  common_txt7: `Número de telefone`,
  common_txt8: `senha`,
  common_txt9: `confirmar senha`,
  common_txt10: `Tesouro`,
  common_txt11: `Ofertas`,
  common_txt12: `Rebate`,
  common_txt13: `Coleta`,
  common_txt14: `Super`,
  common_txt15: `Resgatar`,
  common_txt16: `Roleta`,
  common_txt17: `Agente`,
  common_txt18: `Nível`,
  common_txt19: `Misterioso`,
  common_txt20: `Bônus`,
  common_txt21: `Contatar o Serviço`,
  common_txt22: `Contato`,
  common_txt23: `Suporte`,
  common_txt24: ``,
  common_txt25: `otlotter.com é uma marca administrada pOr GAMEWIZ BRASIL
                LTDA, CNPJN56.195.099/0001-89,devidamente autorizada pelo
                Ministério daFazendasob aAutorizac30 SPA/MFn°2.104-10`,
  common_txt26: `Comissão`,
  common_txt27: `Como Convidar`,
  common_txt28: `Meus Dados`,
  common_txt29: `Detalhes do Subordinado`,
  common_txt30: `
<div>
<p class="m-t-10">
1. O bônus de recarga pode aumentar seu capital de apostas. Claro que você tem o direito de escolher renunciar ao bônus e continuar recarregando.
</p>
<p class="m-t-10">
2. O bônus de recarga requer 1 registro válido de aposta em jogo antes que um pedido de saque possa ser iniciado.
</p>
<p class="m-t-10">
3. Após a conclusão do pagamento, o valor pago será exibido na carteira do jogo. Se você não receber o valor da recarga a tempo, entre em contato com o atendimento online para obter ajuda.
</p>
</div> `,
  common_txt31: `Detalhes do Score de Crédito`,
  common_txt32: `Regras de CP`,
  common_txt33: `Pontuação de Crédito Inicial: Sua conta começa com uma pontuação de crédito de 100 pontos. Quando você modificar informações sensíveis (como seu nome real, senha de saque ou conta bancária) ou tentar saques incorretos repetidamente, o sistema deduirá pontos correspondentes para proteger a segurança da sua conta. Restrições de Saque: Se sua pontuação de crédito cair abaixo de 90 pontos, seus privilégios de saque serão restritos. Para restaurar sua pontuação, você deve: Fazer um novo depósito ou Atualizar seu nível VIP. (Observação: Isso garante a segurança da conta e previne atividades fraudulentas.)`,
  common_txt34: `Desenvolvimento ilimitado dos subordinados`,
  common_txt35: `Descrição da Atividade`,
  common_txt36: `<p class="m-b-10">
          Tempo de liquidação: O sistema liquidará a comissão do dia anterior às 00:00 do dia seguinte.
        </p>
        <p class="m-b-10">
          Convide seus amigos para participar do jogo por meio de diferentes formas: através do nosso site Facebook / Instagram / TikTok / Telegram / WhatsApp / YouTube, etc. Acelere e convide todos os membros que se cadastraram através do seu link exclusivo para se tornarem seus agentes diretos, mas, por favor, observe que os novos membros que você convidar devem ser reais e válidos.
        </p>
        <p class="m-b-10">Principais vantagens:</p>
        <p class="m-b-10">
          1. Receba bônus de convite e altas comissões. Se o seu primeiro depósito for bem-sucedido, você pode ganhar um bônus de 3.000. Por exemplo, se você convidar 10 pessoas a fazerem seu primeiro depósito, você pode ganhar 30.000. Quanto mais pessoas você convidar, mais bônus você receberá. Você pode verificar seu histórico na página de promoção.
        </p>
        <p class="m-b-10">
          2. Se seus convidados apostarem 1 ou mais, você já pode desfrutar de altas comissões! Você pode ganhar até 5% de comissão vitalícia, que é um convite vitalício! Por exemplo: Você tem 100 membros offline, e as apostas diárias reais totais são estimadas em 300 milhões. A comissão que você recebe todos os dias é: 300.000 x 2% = 6.000. É muito fácil ganhar comissões todos os meses.
        </p>`,
  common_txt37: `Roleta`,
  common_txt38: `Compartilhar`,
  common_txt39: `Tesouro`,
  common_txt40: `Envelope`,
  common_txt41: `Resgate`,
  common_txt42: `Jogo`,
  common_txt43: `Registro`,
  common_txt44: `Detalhes `,
  common_txt45: `crédito`,
  common_txt46: `Nome Real`,
  common_txt47: `Número do Cartão`,
  common_txt48: `Nível`,
  common_txt49: `Aposta da Equipe`,
  common_txt50: `Proporção`,
  common_txt51: `Ganho`,
  common_txt52: `regras`,
  common_txt53: `Ganhe ≥`,
  common_txt54: `para reivindicar.`,
  common_txt55: `Saldo:`,
  common_txt56: `Cópia`,
  common_txt57: `Meu link:`,
  common_txt58: `Compartilhamento Rápido`,
  common_txt59: `Forma de pagamento：`,
  common_txt60: `Todos`,
  common_txt61: `Mais`,
  common_txt62: `Lobby`,
  common_txt63: `Categoria de Jogos`,
  common_txt64: `Instalar`,
  common_txt65: `Número incorreto`,
  common_txt66: `Score de Crédito`,
  common_txt67: `Carregando`,
  common_txt68: `para poder retirar`,
  common_txt69: `Resultado da Loteria`,
  common_txt70: `Como jogar`,
  common_txt71: `Escolha Rápida`,
  common_txt72: `Um total de`,
  common_txt73: `apostas`,
  common_txt74: `Preço`,
  common_txt75: `Uma única aposta pode ganhar`,
  common_txt76: `aposta`,
  common_txt77: `Pedido de Loteria`,
  common_txt78: `Vazio`,
  common_txt79: `Tipo de Aposta`,
  common_txt80: `Instruções`,
  common_txt81: `Apostas de hoje`,
  common_txt82: `Resultados`,
  common_txt83: `Selecione pelo menos `,
  common_txt84: ` números.`,
  common_txt85: `Máximo de Vitórias por Bolas`,
  common_txt86: `valor`,
  common_txt87: `Dinheiro:`,
  common_txt88: `Linhas`,
  common_txt89: `Selecionado:`,
  common_txt90: `Total:`,
  common_txt91: `Saldo:`,
  common_txt92: `Aposta`,
  common_txt93: `Você ainda não fez um pedido.`,
  common_txt94: `Para concorrer, vocé pode marcar de 2 a 6 trevos.`,
  common_txt95: `O seu valor de aposta excede o seu saldo.`,
  common_txt96: `Por favor, escolha dois números da sorte.`,
  common_txt97: `Selecione pelo menos um número em cada coluna.`,
  common_txt98: `Escolha o seu mês de sorte. Em todo concurso um mês é sorteado.`,
  common_txt99: `Janeiro`,
  common_txt100: `Fevereiro`,
  common_txt101: `Março`,
  common_txt102: `Abril`,
  common_txt103: `Maio`,
  common_txt104: `Junho`,
  common_txt105: `Julho`,
  common_txt106: `Agosto`,
  common_txt107: `Setembro`,
  common_txt108: `Outubro`,
  common_txt109: `Novembro`,
  common_txt110: `Dezembro`,
  common_txt111: `Escolha pelo menos um mês de sorte.`,
  common_txt112: `Selecione seus números.`,
  common_txt113: `A aposta mínima é `,
  common_txt114: `Por favor, selecione.`,
  common_txt115: `montante:`,
  common_txt116: `Detalhes da Aposta`,
  common_txt117: `Informações do Programa`,
  common_txt118: `Montante da Aposta:`,
  common_txt119: `Hora da Aposta:`,
  common_txt120: `Número do Pedido:`,
  common_txt121: `Conteúdo do Programa`,
  common_txt122: `Odds:`,
  common_txt123: `vezes`,
  common_txt124: `dose, um total de`,
  common_txt125: `doses.`,
  common_txt126: `CONTINUAR`,
  common_txt127: `REVOCAR`,
  common_txt128: `Aposta de Hoje`,
  common_txt129: `Histórico de Apostas`,
  common_txt130: `Oops! Ainda não há dados!`,
  common_txt131: `Pendente`,
  common_txt132: `Concluído`,
  common_txt133: `Bônus`,
  common_txt134: `Perda`,
  common_txt135: `Últimos Resultados`,
  common_txt136: `Últimos Resultados:`,
  common_txt137: `Código de máquina:`,
  common_txt138: `Loteria`,
  common_txt139: `Cassino`,
  common_txt140: `Junte-se ao Telegram`,
  common_txt141: `Comissões equipe`,
  common_txt142: `Resumo de dados`,
  common_txt143: `Valor de recarga`,
  common_txt144: `Jogos de busca`,
  common_txt145: `Sem Jogos`,
  common_txt146: `Procurar`,
  common_txt147: `Jogando no TheLotter`,
  common_txt148: `Como funciona?`,
  common_txt149: `Você joga`,
  common_txt150: `Selecione a loteria que deseja jogar e preencha suas entradas com seus números favoritos.`,
  common_txt151: `Nós compramos`,
  common_txt152: `Compraremos ingressos oficiais em seu nome de um revendedor licenciado e os digitalizaremos em sua conta particular segura e segura.`,
  common_txt153: `Você ganha`,
  common_txt154: `Notificaremos você quando você ganhar e transferiremos seus prêmios para você sem comissão.`,
  common_txt155: `O dinheiro bônus para coleta gratuita é compatível apenas com jogos eletrônicos PG.`,
  common_txt156: `Caro jogador, nosso sistema detectou que seu nível VIP está atualmente baixo. Para a segurança de seus fundos, suas funcionalidades de jogo foram desativadas temporariamente. Por favor, complete um saque bem-sucedido primeiro e depois recarregue para restaurar todas as funcionalidades de jogo.`,
  common_txt157: `Saldo insuficiente, por favor recarregue para continuar.`,
  common_txt158: `Por favor, faça o primeiro depósito.`,
  common_txt159: `O desenvolvedor do jogo está realizando manutenção no jogo, por favor tente novamente mais tarde.`,
  common_txt160: `A funcionalidade do jogo foi desativada. Por favor, entre em contato com o suporte online para obter assistência.`,
  common_txt161: `Tem certeza de que deseja cancelar o pedido?`,
  common_txt162: `sorteio`,
  common_txt163: `Pedido`,
  common_txt164: `otlotter.com é um agente da CAIXA e uma empresa que opera no negócio
              de loteria. Todos os produtos de loteria oferecidos na plataforma
              são fornecidos pela CAIXA e processados pelos agentes oficiais da
              otlotter.com.`,
  common_txt165: `Compartilhar nas Redes Sociais`,
  common_txt166: `Formas de pagamento aceitas:`,
  common_txt167: `Cartöes de crédito, PlX e PicPay.`,
  common_txt168: `Loterias Tron`,
  common_txt169: `Loterias Caixa`,
  common_txt170: `MILHÓES`,
  common_txt171: `Super prêmio`,
  common_txt172: `Eles ganharam o super prêmio`,
  common_txt173: `Prêmios distribuídos`,
  common_txt174: `conta`,
  common_txt175: `loteria`,
  common_txt176: `prêmio`,
  common_txt177: `Confira os últimos resultados das Loterias`,
  common_txt178: `Comprar`,
  common_txt179: `Sorteio realizado no ESPAÇO DA SORTE em SÃO`,
  common_txt180: `PAULO, SP`,
  common_txt181: `validar`,
  common_txt182: `1º sorteio`,
  common_txt183: `2º sorteio`,
  common_txt184: `Confira o resultado da Quina`,
  common_txt185: `otlotter.com é um agente da CAIXA e uma empresa que opera no negócio de
          loteria. Todos os produtos de loteria oferecidos na plataforma são
          fornecidos pela CAIXA e processados pelos agentes oficiais da
          otlotter.com.`,
  common_txt186: `Compartilhar nas Redes Sociais`,
  common_txt187: `Formas de pagamento aceitas:`,
  common_txt188: `Cartões de crédito, PlX e PicPay.`,
  common_txt189: `Tudo`,
  common_txt190: `número`,
  common_txt191: `moeda`,
  common_txt192: `Dia`,
  common_txt193: `Registro de Apostas`,
  common_txt194: `Desenhado`,
  common_txt195: `Não Desenhado`,
  common_txt196: `Hora da aposta`,
  common_txt197: `valor`,
  common_txt198: `Prêmio total`,
  common_txt199: `Não premiado`,
  common_txt200: `Prêmio cancelado`,
  common_txt201: `Ganhou`,
  common_txt202: `Cancelamento do sistema`,
  common_txt203: `A ser sorteado`,
  common_txt204: `ganhar`,
  common_txt205: `vezes,`,
  common_txt206: `apostas, custou um total de`,
  common_txt207: `Apostar agora`,
  common_txt208: `Encerramento das Apostas`,
  common_txt209: `edição da loteria`,
  common_txt210: `a edição anterior :`,
  common_txt211: `ª fila`,
  common_txt212: `O sistema não suporta, por enquanto, apostas em loterias diferentes
          numa única aposta. Se continuar, o carrinho será esvaziado!`,
  common_txt213: `continuar`,
  common_txt214: `A aposta da atual rodada de loteria foi encerrada e a nova aposta já começou.`,
  common_txt215: `Tenho mais de 18 anos de idade e li eaceitei os Termos de Uso e o Aviso dePrivacidade.`,
  common_txt216: `Sim, quero receber ofertas e descontosexclusivos!`,
  common_txt217: `Nº Emissão`,
  common_txt218: `Montante`,
  common_txt219: `Estado`,
  common_txt220: `Prémio`,
  common_txt221: `1. Não há limite para o número de saques por dia, e o otlotter.com oferece
          suporte a saques online 24 horas por dia.`,
  common_txt222: `2. O valor mínimo para um único saque é de`,
  common_txt223: `BRL. Não é possível iniciar uma solicitação de saque para valores menores que isso.`,
  common_txt224: `3. Cada usuário pode iniciar apenas uma solicitação de saque por vez. Uma nova solicitação de saque só pode ser iniciada após a anterior ter sido processada.`,
  common_txt225: `4. Normalmente, o seu saque chegará à sua conta bancária em 1 minuto.
          Se você não receber o valor do saque por um longo tempo, por favor,
          entre em contato com o centro de atendimento ao cliente para
          assistência.`,
  common_txt226: `Total Gasto:`,
  common_txt227: `Prêmio Total:`,
  common_txt228: `REEMBOLSO<br/>PORPERDA NO JOGO`,
  common_txt229: `CASHBACK DE ATÃ 5O%`,
  common_txt230: `RODA GRATUITA`,
  common_txt231: `FACA LOGIN PARA <br/>RECEBERRECOMPENSAS <br/>EXTRAS`,
  common_txt232: `ABRA SUA<br/>CAIXA DE SORTE`,
  common_txt233: `O PRÃMIO MÁXIMO PODE<br/>CHEGAR A`,
  common_txt234: `MEMBRO VIP`,
  common_txt235: `PRÃMIO DE UPGRADE VIP<br/>PRÃMIO MENSAL VIP<br/>MAIS PRÈMIOS VIP ABUNDANTES`,
  common_txt236: `CHUVA DE<br/>PACOTES DE<br/>DINHEIRO DIARIA`,
  common_txt237: ``,
  common_txt238: `BÃNUS DERECARGA`,
  common_txt239: `QUANTO MAIS<br/>RECARGASACUMULADAS,<br/>MAIORES AS SURPRESAS`,
  common_txt240: `PREMIO DE<br/>APOSTAEM EOUIPE`,
  common_txt241: `SUA EOUIPE RECEBERA <br/>UMARECOMPENSA DE <br/>CASHBACKTODAS AS SEMANAS`,
  common_txt242: `COMISSAO DE<br/>CONVITE`,
  common_txt243: `QUANTO MAIS PESSOASCON<br/>VIDADAS, MAIOR OBÃNUS `,
  common_txt244: `MEMBRO VIP`,
  common_txt245: `Acesso diário e check-in do<br/>VIP garantem recompensas <br/>generosas`,
  common_txt246: `Escolha conectar-se à rede:`,
  common_txt247: `efetivamente recebido BRL`,
  common_txt248: `Regressivo de Pagamento`,
  common_txt249: `Endereço de Depósito`,
  common_txt250: `Copiar Endereço`,
  common_txt251: `Pagamento Concluído`,
  common_txt252: `Pagamento Expirado`,
  common_txt253: `1.Complete o pagamento antes do término do cronômetro do pedido.`,
  common_txt254: `2.Você pode obter o endereço da carteira escaneando o código QR ou copiando-o.`,
  common_txt255: `3.Selecione a rede correta ao efetuar o pagamento.`,
  mc_title: 'Centro de Missões',
  mc_daily: 'Diário',
  mc_weekly: 'Semanal',
  mc_activity_points: 'Pontos de Atividade',
  mc_reset_in: 'Reinicia em',
  mc_todays_missions: 'Missões de Hoje',
  mc_weekly_missions: 'Missões Semanais',
  mc_claim: 'Resgatar',
  mc_claimed: 'Resgatado',
  mc_go: 'Ir',
  mc_pts: 'Pts',
  mc_claim_failed: 'Falha ao resgatar',
  mc_rules_title: 'Regras da Atividade',
  mc_rule_1: 'Os jogadores receberão uma lista de missões diárias simples ao fazer login.',
  mc_rule_2: 'Complete uma missão para receber a recompensa diária e acumular pontos.',
  mc_rule_3: 'Alcance marcos específicos de pontos para desbloquear recompensas adicionais.',
  mc_rule_4: 'Complete todas as missões para reivindicar o grande prêmio final.',
  profile_account_name: 'Nome da conta',
  profile_real_name: 'Autenticação de Nome Real',
  profile_login_pass: 'Alterar senha de login',
  profile_withdraw_pass: 'Senha de Saque',
  profile_bank_card: 'Cartão Bancário',
  profile_avatar: 'Avatar',
  profile_privacy: 'Política de Privacidade',

  // ====== Settings Page ======
  settings_title: 'Configurações',
  settings_account_security: 'SEGURANÇA DA CONTA',
  settings_email: 'Endereço de e-mail',
  settings_not_set: 'Não definido',
  settings_bind: 'VINCULAR',
  settings_unbind: 'DESVINCULAR',
  settings_social_binding: 'VÍNCULOS SOCIAIS',
  settings_preferences: 'PREFERÊNCIAS',
  settings_language: 'Idioma',
  settings_push: 'Notificações push',
  settings_sound: 'Volume do som',
  settings_bind_phone: 'Vincular telefone',
  settings_not_bound: 'Não vinculado',

  // ====== Edit Profile Page ======
  editProfile_title: 'EDITAR PERFIL',
  editProfile_save: 'SALVAR',
  editProfile_user_id: 'ID do usuário',
  editProfile_nickname: 'Apelido',
  editProfile_nickname_ph: 'Digite o apelido',
  editProfile_birthday: 'Data de nascimento',

  // ====== Password Success Page ======
  pwdSuccess_header: 'SENHA ATUALIZADA',
  pwdSuccess_title: 'Atualizado com sucesso!',
  pwdSuccess_desc: 'Sua senha foi alterada. Use suas novas credenciais para logins futuros.',
  pwdSuccess_done: 'CONCLUÍDO',
  pwdSuccess_footer: 'Gerenciamento seguro de conta',
  pwdConfirm_ph: 'Confirmar nova senha',
  pwdConfirm_mismatch: 'As senhas não coincidem',

  // ====== Transaction Records Page ======
  txRecords_title: 'Histórico de transações',

  // ====== Phone Unbound Page ======
  phoneUnbound_title: 'SEGURANÇA DO TELEFONE',
  phoneUnbound_status: 'NENHUM NÚMERO DE TELEFONE VINCULADO',
  phoneUnbound_desc: 'Vincule seu número de telefone para melhorar a segurança da conta, ativar alertas por SMS e recuperar facilmente sua conta.',
  phoneUnbound_bind: 'VINCULAR TELEFONE',
  phoneUnbound_level: 'Nível de segurança:',

  // ====== Mine Page ======
  mine_main: 'Principal',
  mine_bonus: 'Bônus',
  mine_cashback: 'Cashback',
  mine_community: 'Comunidade',
  // ====== Tab Bar ======
  tab_menu: 'Menu',
  tab_promotions: 'Promoções',

  // ====== Google Login ======
  google_login: 'Entrar com Google',
  google_register_title: 'Completar Registro',
  google_register_phone: 'Digite o número do telefone',
  google_login_url_failed: 'Falha ao obter URL de login do Google',
  google_login_failed: 'Falha no login do Google',
  google_register_failed: 'Falha no registro',
  network_error: 'Erro de rede',
  common_loading: 'Carregando...',
  login_captcha_placeholder: 'Digite o código de verificação',
  login_captcha_send: 'Enviar',
  // ====== VIP ======
  vip_title: 'Níveis VIP',
  vip_level_progress: 'Progresso do Nível',
  vip_tier_advancement: 'Avanço de Nível',
  vip_xp_remaining: 'XP restantes para alcançar o Nível',
  vip_exclusive_privileges: 'Privilégios Exclusivos',
  vip_level_up_reward: 'Recompensa de Subida',
  vip_daily_reward: 'Recompensa Diária',
  vip_birthday_gift: 'Presente de Aniversário',
  vip_withdrawal_fee: 'Taxa de saque isenta',
  vip_daily_withdrawal: 'Saque Diário',
  vip_withdrawal_limit: 'Limite de Saque',
  vip_loss_rebate: 'Reembolso de Perda',
  vip_locked: 'Bloqueado',
  vip_my_gifts: 'Meus Presentes',
  vip_not_reached: 'Não alcançado',
  vip_claimable: 'Disponível',
  vip_claimed: 'Resgatado',

  // ====== Google Phone Bind ======
  gpb_title: 'Vincular Telefone',
  gpb_desc: 'Por favor, vincule seu número de telefone para concluir o registro',
  gpb_phone_placeholder: 'Digite o número de telefone',
  gpb_confirm: 'Confirmar Vínculo',
  gpb_confirm_title: 'Aviso',
  gpb_confirm_msg: 'Não vincular o telefone fará logout. Tem certeza?',
  gpb_confirm_yes: 'Sim',
  gpb_confirm_no: 'Não',

  // ====== Newbie Gift ======
  ng_title: 'Presente Exclusivo para Novatos',
  ng_limited_time: 'Tempo Restante Limitado',
  ng_limited_price: 'Preço Limitado',
  ng_buy_now: 'Comprar Agora',
  ng_claim: 'Resgatar',
  ng_claimed: 'Resgatado',
  ng_disclaimer: 'Limitado a uma compra por usuário. Termos e condições se aplicam.',
  ng_total_reward: 'Recompensa Total de 3 Dias',
  ng_day1_title: 'Recompensa do Dia 1',
  ng_day1_desc: 'Ganhe <span class="highlight">100% Bônus de Depósito</span> + Pacote Dia 1 + <span class="highlight">100 Moedas Extra</span>',
  ng_day2_title: 'Recompensa do Dia 2',
  ng_day2_desc: 'Volte amanhã para <span class="highlight">200 Moedas Extra</span>',
  ng_day3_title: 'Grande Recompensa Final',
  ng_day3_desc: 'Desbloqueie o prêmio misterioso: <span class="highlight">500 Moedas Extra</span>',
  activity_coming_soon: 'Em Breve',
  activity_stay_tuned: 'Fique atento, estamos preparando algo incrível!',
  rp_title: 'Chuva de Pacotes Vermelhos',
  rp_not_qualified: 'Faça um depósito para desbloquear',
  rp_not_open: 'Atividade ainda não aberta',
  rp_not_open_desc: 'Volte mais tarde',
  rp_not_qualified_desc: 'Faça um depósito nos últimos 3 dias para participar',
  rp_countdown: 'Próxima Rodada Em',
  rp_round_active: 'Toque para pegar!',
  rp_claimed: 'Já resgatado nesta rodada',
  rp_round_ended: 'Rodada Encerrada',
  rp_next_round: 'Próxima Rodada',
  rp_remaining: 'Restante',
  rp_clicks: 'Cliques',
  rp_total_award: 'Prêmio Total',
  rp_your_reward: 'Sua Recompensa',
  rp_go_deposit: 'Depositar',
  rp_history: 'Histórico',
  rp_rules_title: 'Como Jogar',
  rp_rule_1: 'Deposite nos últimos 3 dias para se qualificar',
  rp_rule_2: 'Toque nos pacotes vermelhos para ganhar',
  rp_rule_3: 'Cada rodada tem cliques limitados',
  rp_no_history: 'Nenhum registro ainda',
  rp_packets_left: 'Pacotes Restantes',
  rp_round_time: 'Horário da Rodada',
  rp_grab_success: 'Parabéns!',
  // ====== Additional i18n Keys ======
  checkin_premium_desc: 'Recompensas premium são desbloqueadas após depósito diário. Acumule 10 depósitos para um Mega Giro!',
  checkin_coins: 'Moedas',
  checkin_deposit_for: 'DEPOSITAR PARA',
  checkin_missed: 'PERDIDO',
  lr_title: 'INDICAÇÃO SORTUDA',
  lr_spin_x: 'GIRAR',
  lr_live_feed: 'Ao Vivo',
  lr_target_reward: 'Recompensa Alvo',
  lr_current_earnings: 'Ganhos Atuais',
  lr_spins_hint: 'Resgate todas as recompensas quando a barra de progresso estiver totalmente preenchida.',
  lr_claim_reward: 'Resgatar Recompensa',
  lr_spinning: 'Girando...',
  lr_referral_link: 'Link de Indicação',
  lr_copy: 'Copiar',
  lr_rules_highlight: 'Como funciona:',
  lr_rules_desc: 'Convide amigos e ganhe giros grátis. Cada giro ganha recompensas. Alcance a meta para desbloquear o prêmio máximo!',
  lr_recent_winners: 'Ganhadores Recentes',
  lr_player_name: 'Jogador',
  lr_reward_amount: 'Recompensa',
  lr_insufficient_spins: 'Giros Insuficientes',
  lr_invite_more: 'Convide mais amigos para ganhar giros grátis!',
  lr_close: 'Fechar',
  ng_best_value: 'MELHOR VALOR',
  ng_active: 'Ativo',
  ng_total_value: 'VALOR TOTAL',
  menu_region: 'Região',
  reward_no_data: 'Nenhuma recompensa encontrada',
  reward_history: 'Histórico de Recompensas',
  reward_your_rewards: 'Suas Recompensas',
  reward_claimed: 'RESGATADO',
  reward_locked: 'BLOQUEADO',
  reward_claim_coins: 'RESGATAR',
  reward_go_deposit: 'Ir para Depósito',
  reward_deposit_tip: 'Deposite hoje para desbloquear recompensas premium!',
  reward_deposit_signin: 'Check-in com Depósito',
  reward_regular_signin: 'Check-in Regular',
  reward_premium: 'PREMIUM',
  reward_confirm: 'Confirmar Seleção',
  reward_cancel: 'Cancelar',
  rp_hour: 'H',
  rp_min: 'M',
  rp_sec: 'S',
  // ====== Activity Page Keys (PT) ======
  activity_tab: 'Atividades',
  activity_new: 'NOVO',
  activity_events: 'Eventos',
  activity_active: 'Ativo',
  activity_daily_checkin: 'CHECK-IN DIÁRIO',
  activity_day: 'Dia',
  activity_rules: 'Regras',
  activity_details: 'Detalhes',
  activity_limited_offers: 'Ofertas Limitadas',
  activity_more_events: 'Mais Eventos',
  activity_welcome_bonus: 'Bônus de Boas-vindas',
  activity_welcome_bonus_desc: '100% até $200',
  activity_first_deposit_chest: 'Baú do Primeiro Depósito',
  activity_first_deposit_chest_desc: 'Desbloqueio instantâneo',
  activity_season_pass: 'Passe de Temporada',
  activity_season_pass_desc: 'Desbloqueie níveis premium exclusivos',
  activity_lucky_spin: 'Giro da Sorte',
  activity_lucky_spin_desc: 'Giro grátis a cada 12 horas',
  activity_weekly_missions: 'Missões Semanais',
  activity_weekly_missions_desc: 'Complete missões para ganhar recompensas',
  activity_red_envelope: 'Chuva de Envelopes',
  activity_red_envelope_desc: 'Ganhe prêmios em dinheiro',
  activity_spin: 'Girar',
  activity_view: 'Ver',
  activity_join: 'Participar',
  activity_invite_earn: 'Convidar e Ganhar',
  activity_invite_earn_desc: 'Convide amigos para se registrar e depositar para ganhar recompensas em dinheiro.',
  fd_title: 'Presente do Primeiro Depósito',
  fd_title_short: 'Primeiro Depósito',
  fd_gift: 'Presente',
  fd_total_value: 'Valor Total',
  fd_energy_expires: 'A oferta expira quando a energia acabar',
  fd_mission_briefing: 'Briefing da Missão',
  fd_total_reward_value: 'Valor Total da Recompensa',
  fd_critical_deadline: 'Prazo Crítico',
  fd_energy_critical: 'Nível de Energia: Status Crítico',
  fd_claim_now: 'Resgatar Agora',
  fd_offer_ends_energy: 'A oferta termina quando a energia acabar',
  tb_treasure_box: 'Baú do',
  tb_box: 'Tesouro',
  fr_title_short: 'Primeiro Depósito',
  fr_bonus: 'Bônus',
  fr_recharge_now: 'Depositar Agora',
  fr_up_to_prefix: 'Receba até',
  fr_up_to_suffix: 'de recompensas.',
  fr_limited_offer: 'Oferta Limitada',
  fr_next_unlock: 'Próximo Desbloqueio',
  fr_day: 'Dia',
  fr_claimed: 'Recebido',
  fr_locked: 'Bloqueado',
  fr_daily_hint: 'Volte todos os dias para receber sua recompensa.',
  rc_first_deposit_bonus: 'Bônus do primeiro depósito',
  vip_level_text: 'Nível',
  vip_recharge_progress: 'PROGRESSO DE RECARGA',
  vip_bet_progress: 'PROGRESSO DE APOSTA',
  vip_next_level: 'PRÓXIMO NÍVEL'
}
